import { React, useState, useEffect, useContext, useRef, useCallback } from 'react'

import "../css/PagesCommonStyle.css"
import { faMagnifyingGlass, faPrint, faCircleCheck, faShieldHalved } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileExcel, faFilePdf, faTrashCan, faFile, faEye, faEyeSlash } from '@fortawesome/free-regular-svg-icons'
import { useSelector, useDispatch } from 'react-redux';
import { faArrowsRotate, faXmark, faArrowRight, faSpinner, faStar } from '@fortawesome/free-solid-svg-icons'
import { APIConstants, IntelliBillConstants, ClaimApprovalConstants, CommonAPIConstants, FilesAPIConstants } from '../utilities/Constants'

import { Link } from 'react-router-dom'
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { format } from 'date-fns';
import { FixedSizeList as List } from 'react-window'
import Draggable from 'react-draggable'
import { exportExcel } from '../utilities/exportToExcel'




const ClaimApproval = () => {

  const getCurrentDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  // Default value for the input is the current date
  const defaultDate = getCurrentDate();
  const defaultFromDate = new Date('2015-01-01');

  const today = new Date();
  const formatCurDate = format(today, 'MM/dd/yyyy');

  const [isHideChecked, setIsHideChecked] = useState(false);
  const [updatedTabledata, setUpdatedTableData] = useState([]);
  const [error, setError] = useState(null);
  const [startDate, setStartDate] = useState(formatCurDate, defaultFromDate); // State to store start date
  const [endDate, setEndDate] = useState(formatCurDate);     // State to store end date
  const [loading, setLoading] = useState(true);


  const ServiceLocValues = [
    { TextField: 'Office - 11', ValueField: '11' },
    { TextField: 'Home - 12', ValueField: '12' },
    { TextField: 'SUD - 57', ValueField: '57' },
    { TextField: 'Lab - 81', ValueField: '81' },


  ];

  const [ServiceLocations, setServiceLocations] = useState([]);
  const [selectedCMS33a, setSelectedCMS33a] = useState('0');
  const [selectedCMS33b, setSelectedCMS33b] = useState('0');
  const [selectedBillingNPI, setSelectedBillingNPI] = useState('0');
  const [selectedPracticeProvider, setSelectedPracticeProvider] = useState('0');
  const [selectedProvidersCategory, setSelectedProvidersCategory] = useState('0');
  const [selectedSearchFilter, setSelectedSearchFilter] = useState('updatedby');
  const [selectedLocation, setSelectedLocation] = useState('-1');
  const [selectedStatusRadioButton, setSelectedStatusRadioButton] = useState('0');
  const [selectedCheckedRadioButton, setSelectedCheckedRadioButton] = useState('0');
  const [selectedServiceLocation, setSelectedServicelocation] = useState('0');
  const [selectedFilterProvider, setSelectedFilterProvider] = useState('0');


  const [locations, setLocations] = useState([]);
  const [cms33aData, setCMS33aData] = useState([]);
  const [cms33bData, setCMS33bData] = useState([]);
  const [providerCategory, setProviderCategory] = useState([]);
  const [searchFilterData, setSearchFilterData] = useState([]);
  const [practiceProvider, setPracticeProvider] = useState([]);
  const [statusRadioButton, setStatusRadioButton] = useState([]);
  const [checkedRadioButton, setCheckedRadioButton] = useState([]);

  const [BillingNPIs, setBillingNPIs] = useState([]);

  const [searchText, setSearchText] = useState('');
  const [searchPatientText, setSearchPatientText] = useState('');
  const [searchProvidersText, setSearchProvidersText] = useState('');
  const [searchInsuranceText, setSearchInsuranceText] = useState('');
  const [selectedFilter, setSelectedFilter] = useState('');
  const [suggestions, setSuggestions] = useState([]);
  const [isTextBoxDisabled, setIsTextBoxDisabled] = useState(true);
  const [issuggestionBoxDisabled, setIsSuggestionBoxDisabled] = useState(true);
  const [sPatID, setSPatID] = useState('');
  const [sClaimStatus, setsClaimStatus] = useState('0');
  const [rowsValidation, setRowsValidation] = useState('');
  const [isChecked, setIsChecked] = useState(false);
  const [sInsID, setSInsID] = useState('');



  const [tableDetails, setTableDetails] = useState([]);
  const [tableInsDetails, setTableInsDetails] = useState([]);
  const [checkEligibility, setCheckEligibility] = useState([]);
  const [selectedClaims, setSelectedClaims] = useState([]);
  const [selectAllDropdown, setSelectAllDropdown] = useState([]);
  const [checkboxes, setCheckboxes] = useState();

  const [searchPatientData, setSearchPatientData] = useState([]);
  const [suggestionProviders, setSuggestionProviders] = useState('');
  const [suggestionInsurance, setSuggestionInsurance] = useState('');
  const [patientList, setPatientList] = useState('');




  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedSendRows, setSelectedSendRows] = useState([]);
  const [selectedLocationRows, setSelectedLocationRows] = useState([]);
  const [selectedValueLocRows, setSelectedValueLocRows] = useState([]);
  const [UnitChargeRows, setUnitChargeRows] = useState([]);
  const [unitCheckbox, setUnitCheckbox] = useState([]);
  const [diag4AllCheckbox, setDiag4AllCheckbox] = useState([]);
  const [diag3AllCheckbox, setDiag3AllCheckbox] = useState([]);
  const [diag2AllCheckbox, setDiag2AllCheckbox] = useState([]);
  const [diag1AllCheckbox, setDiag1AllCheckbox] = useState([]);
  const [mod3AllCheckbox, setMod3AllCheckbox] = useState([]);
  const [mod2AllCheckbox, setMod2AllCheckbox] = useState([]);
  const [mod1AllCheckbox, setMod1AllCheckbox] = useState([]);
  const [cptAllCheckbox, setCptAllCheckbox] = useState([]);
  const [providerAllCheckbox, setProviderAllCheckbox] = useState([]);
  const [insuranceAllCheckbox, setInsuranceAllCheckbox] = useState([]);
  const [filteredTableDetails, setFilteredTableDetails] = useState(tableDetails);


  const [searchByPatient, setSearchByPatient] = useState('');
  const [searchByDOB, setSearchByDOB] = useState('');
  const [searchByInsurance, setSearchByInsurance] = useState('');
  const [searchByProvider, setSearchByProvider] = useState('');
  const [searchByCPT, setSearchByCPT] = useState('');
  const [searchByDOS, setSearchByDOS] = useState('');
  const [searchByPostingDate, setSearchByPostingDate] = useState('');
  const [searchBySubmitdate, setSearchBySubmitdate] = useState('');
  const [searchByICD, setSearchByICD] = useState('');
  const [searchByTotalCharge, setSearchByTotalCharge] = useState('');
  const [searchByStatus, setSearchByStatus] = useState('');
  const [searchByRecievedCharge, setSearchByRecievedCharge] = useState('');
  const [searchByUpdatedBy, setSearchByUpdatedBy] = useState('');
  const [searchBySubmitter, setSearchBySubmitter] = useState('');
  const [searchByClaim, setSearchByClaim] = useState('');
  const [searchByModifier, setSearchByModifier] = useState('');


  const [selectedTextField, setSelectedTextField] = useState('');
  const [selectedValueField, setSelectedValueField] = useState('');
  const [selectedRecValue, setSelectedRecValue] = useState('all'); // Default value is 25
  const [totalRecords, setTotalRecords] = useState(0);
  const [displayedRecords, setDisplayedRecords] = useState([]);
  const [selectedDropdownValue, setSelectedDropdownValue] = useState('PostingDate');
  const [selectedDropdownValue2, setSelectedDropdownValue2] = useState('1');

  const [showSelectErrorModal, setShowSelectErrorModal] = useState(false);
  const [showConfirmSaveModal, setShowConfirmSaveModal] = useState(false);
  const [showApprovalSaveModal, setShowApprovalSaveModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteSuccessModal, setDeleteSuccessModal] = useState(false);
  const [closeClaimsModal, setCloseClaimsModal] = useState(false);
  const [savedRowCount, setSavedRowCount] = useState(0);
  const [deleteRowCount, setDeleteRowCount] = useState(0);
  const [successTimer, setSuccessTimer] = useState(5000);

  const [appointmentDates, setAppointmentDates] = useState([]);
  const [selectLocationID, setSelectLocationID] = useState('0');
  const [activeRow, setActiveRow] = useState(null);
  const [claimStatusCount, setclaimStatusCount] = useState([]);
  const [ClearingHouse, setClearingHouse] = useState('');
  const [selectClearinghouse, setSelectClearingHouse] = useState([]);
  const [isPageLoad, setisPageLoad] = useState('1');

  const [eventData, setEventData] = useState([]);
  const [selectedClaimID, setselectedClaimID] = useState([]);
  const [showFaxModal, setShowFaxModal] = useState(false);
  const [hasFetched, setHasFetched] = useState(false);

  const [isLoading, setIsLoading] = useState(false);
  const [isInStatus, setIsInStatus] = useState('');
  const [policyStatus, setPolicyStatus] = useState({});
  const [loadingRows, setLoadingRows] = useState([]);
  const [patientID, setpatientID] = useState('');
  const [rowState, setRowState] = useState({});
  const [claimID, setClaimID] = useState('');
  const [isHidden, setIsHidden] = useState(false);
  const [isStartOpen, setIsStartOpen] = useState(false);
  const [isEndOpen, setIsEndOpen] = useState(false);
  const [epin, setEpin] = useState('');
  const [verifiedEpin, setverifiedEpin] = useState('');
  const [isEPINVerifiedModal, setIsEPINVerifiedModal] = useState(false);
  const rowsPerPage = 200;
  const [visibleRecords, setVisibleRecords] = useState(rowsPerPage);
  const [sortConfig, setSortConfig] = useState({ key: '', direction: 'asc' });
  const [activeCounts, setActiveCounts] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");
  const [reGenerateData, setReGenerateData] = useState(false);
  const [attachmentData, setAttachmentData] = useState([]);
  const [showattachmentData, setShowAttachmentData] = useState(false);
  const [attachmentClaimID, setattachmentClaimID] = useState('');
  const dispatch = useDispatch();

  const tableContainerRef = useRef(null);



  const loadMoreRecords = useCallback(() => {
    setVisibleRecords((prev) => {
      const next = Math.min(prev + rowsPerPage, displayedRecords.length);


      if (next > prev) {
        setPopupMessage(`${next} records out of ${displayedRecords.length} loaded`);
        setShowPopup(true);


        setTimeout(() => {
          setShowPopup(false);
        }, 3000);
      }

      return next;
    });
  }, [displayedRecords.length]);




  const handleScroll = useCallback(() => {
    const isAtBottom =
      window.innerHeight + window.scrollY >= document.documentElement.scrollHeight;

    if (isAtBottom) {
      loadMoreRecords();
    }
  }, [loadMoreRecords]);




  useEffect(() => {
    setVisibleRecords(rowsPerPage);
  }, [displayedRecords]);




  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [handleScroll]);




  const userData = useSelector((state) => state.user.user);


  localStorage.setItem('userData', JSON.stringify(userData));


  var userPracticeID = userData ? userData.practiceID : null;

  var userId = userData ? userData.userID : null;

  const sAuthToken = useSelector((state) => state.user.token);


  useEffect(() => {


    document.title = 'Approval'


    let timerId;

    setSearchText(userData.userFullName);

    if (showSuccessModal || deleteSuccessModal || isEPINVerifiedModal) {
      // Start the timer when the success modal is shown
      timerId = setTimeout(() => {
        setShowSuccessModal(false);
        setDeleteSuccessModal(false);
        setIsEPINVerifiedModal(false);

      }, successTimer);
    }


    return () => {
      clearTimeout(timerId);
    };
  }, [showSuccessModal, successTimer, deleteSuccessModal, isEPINVerifiedModal]);



  useEffect(() => {
    setEpin("");
  }, []);


  useEffect(() => {
    // Set the default last 7 days' date range
    const today = new Date();
    const sevenDaysAgo = new Date(today);
    sevenDaysAgo.setDate(today.getDate() - 7);

    setStartDate(sevenDaysAgo);
    setEndDate(today);

    setSPatID(userId);



  }, []);





  useEffect(() => {

    if (!hasFetched && sPatID && searchText) {
      handleTableDataClick();
      GetClaimPracticeCount();
      setHasFetched(true);
    }
  }, [sPatID, hasFetched, searchText]);




  const handleStartDateChange = (date) => {
    if (date) {
      const formattedDate = format(date, 'MM/dd/yyyy');
      setStartDate(formattedDate);
      setEndDate(formattedDate)
      setIsStartOpen(false)

    } else {
      setStartDate(null);
    }
  };


  const handleEndDateChange = (date) => {

    if (date) {
      const formattedDate = format(date, 'MM/dd/yyyy');
      setEndDate(formattedDate);

      setIsEndOpen(false)

    } else {
      setEndDate(null);
    }
  };





  const getMonths = (selectedYear) => {
    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth();

    return Array.from({ length: 12 }, (v, k) => {
      if (selectedYear === currentYear && k > currentMonth) {
        return null;
      }
      return (
        <option key={k} value={k}>
          {format(new Date(selectedYear, k), 'MMMM')}
        </option>
      );
    }).filter(option => option !== null);
  };








  const handleTodayClick = (dateType) => {
    const today = new Date();

    if (dateType === "start" && startDate) {
      setStartDate(today);
      setEndDate(today);
      setIsStartOpen(false);
    }

    if (dateType === "end" && endDate) {
      setEndDate(today);
      setIsEndOpen(false);
    }
  };



  const CalendarContainer = ({ children }) => (
    <div style={{ zIndex: '99px', backgroundColor: 'white', border: '1px solid lightgray' }}>
      {children}
      <div style={{ justifyContent: 'center', padding: '10px', borderTop: '1px solid #ddd', marginLeft: '65px' }}>
        <button type="button" className='today-btn' onClick={() => handleTodayClick("end")}>
          Today
        </button>

      </div>
    </div>
  );


  const CalendarStartContainer = ({ children }) => (
    <div style={{ zIndex: '99px', backgroundColor: 'white', border: '1px solid lightgray' }}>
      {children}
      <div style={{ justifyContent: 'center', padding: '10px', borderTop: '1px solid #ddd', marginLeft: '65px' }}>
        <button type="button" className='today-btn' onClick={() => handleTodayClick("start")}>
          Today
        </button>

      </div>
    </div>
  );









  const isValidDate = (dateString) => {
    const regEx = /^\d{4}-\d{2}-\d{2}$/;
    return dateString.match(regEx) !== null;
  };

  // Function to format dates as "yyyy-MM-dd"
  const formatDate = (dateString) => {
    const [year, month, day] = dateString.split('-');
    const formattedMonth = month.padStart(2, '0');
    const formattedDay = day.padStart(2, '0');
    return `${year}-${formattedMonth}-${formattedDay}`;
  };



  const handleHideCheckboxChange = () => {
    setIsHideChecked(!isHideChecked);

    if (isHideChecked) {
      // Reset to original dates
      setStartDate(formatCurDate);
      setEndDate(formatCurDate);
    } else {
      // Set FROM date to 1/1/2015 and TO date to the current date
      setStartDate('1/1/2015');
      setEndDate(formatCurDate);
    }
  };




  // Api Integration of all Dropdowns

  useEffect(() => {


    // Load stored userData from localStorage on component mount
    const storedUserData = localStorage.getItem('userData');
    var inputStruct = {

      LoggedInUserDetails: userData

    }

    var myInput = { sInputJSON: JSON.stringify(userData) };


    myInput = JSON.stringify(myInput);

    const response = fetch(APIConstants.BASE_URL + ClaimApprovalConstants.GetClaimDropDowns, {
      method: 'POST',
      headers: {

        'Accept': 'application/json',
        'Content-Type': 'application/json'

      },

      body: myInput
    })


      .then((response) => response.json())
      .then((data) => {
        // Extract the relevant data from the response
        const parsedData = JSON.parse(data.d);
        const dropdownData = parsedData.Data;

        setSelectAllDropdown(dropdownData);
        // Populate the dropdowns with the received data
        setLocations(dropdownData.LocationDetails)

        setCMS33aData(dropdownData.CMSbox33aData);
        setCMS33bData(dropdownData.CMSbox33bData);
        setBillingNPIs(dropdownData.PracticeBillingNPIs);
        setServiceLocations(dropdownData.ServiceLocation);
        setPracticeProvider(dropdownData.PracticeProviders);
        setProviderCategory(dropdownData.ProvidersCategories);
        setSearchFilterData(dropdownData.SearchByFilters);
        setStatusRadioButton(dropdownData.StatusRadioButtons);
        setCheckedRadioButton(dropdownData.CheckedInRadioButtons);
        setLoading(false);


      })

      .catch((error) => {
        console.error('Error fetching data: ', error);
      });

  }, [userData])






  const convertValueToNumber = (selectedValue) => {
    switch (selectedValue) {
      case 'AppointmentDate':
        return 0;
      case 'PostingDate':
        return 1;
      case 'SubmitDate':
        return 2;
      default:
        return 0;
    }
  };




  const handleLocationChange = (e, item) => {
    const newSelectedLocation = e.target.value;
    setSelectedLocation(newSelectedLocation || (item.LocationId));
    setSelectLocationID(newSelectedLocation || (item.LocationId));

    localStorage.setItem('selectedLocation', newSelectedLocation);
  };








  const handleRadioButtonsChange = (e) => {

    setSelectedStatusRadioButton(e.target.value);
    localStorage.setItem('selectedStatusRadioButton', e.target.value);
    const selectedValue = e.target.value;
    setsClaimStatus(selectedValue);



    if (selectedValue !== '0') {
      setsClaimStatus(selectedValue);
    } else {
      setsClaimStatus('');
    }

  }




  useEffect(() => {

    if (sClaimStatus !== '0') {
      handleTableDataClick();
      GetClaimPracticeCount()
    }


  }, [sClaimStatus]);










  const [hasUpdatedByBeenSelected, setHasUpdatedByBeenSelected] = useState(false);
  const [hasTableDataClicked, setHasTableDataClicked] = useState(false);







  useEffect(() => {


  }, [sInsID]);













  const handleFilterChange = (event) => {
    setIsTextBoxDisabled(selectedSearchFilter === '');

    setSearchText('');
    //setSPatID('')
    setSelectedSearchFilter(event.target.value);


  }




  const handleInputKeyPress = (event) => {
    if (event.key === 'Backspace') {
      // Handle backspace key
      if (searchText === '' && suggestions.length > 0) {
        setSuggestions([]);
        setSPatID('');

      } else {
        // Remove the last character from searchText
        const updatedSearchText = searchText.slice(0, -1);
        setSearchText(updatedSearchText);

        // Fetch suggestions based on the selected search filter
        fetchSuggestions(updatedSearchText);
      }
    } else if (event.key !== 'Enter') {
      // Handle other key presses
      setSearchText(event.target.value);
      fetchSuggestions(event.target.value);
    }
  };



  const fetchSuggestions = (text) => {

    if (selectedSearchFilter === 'pat') {
      fetchPatientNames(text);

    } else if (selectedSearchFilter === 'updatedby') {
      fetchUpdatedBy(text);
    } else if (selectedSearchFilter === 'ins') {
      fetchInsuranceCompanies(text);
    } else if (selectedSearchFilter === 'submittedby') {
      fetchSubmittedBy(text);
    } else if (selectedSearchFilter === 'renderingprovider') {
      fetchSearchProviders(text);
    }
  };







  const hasLoadedInitially = useRef(false);



  const handleSuggestionSelect = (item) => {

    setSearchText(item.label || item.val);

    setSuggestions([]);

    const patientId = item.val;

    if (selectedSearchFilter) {
      if (selectedSearchFilter === 'pat') {

        setSPatID(patientId);
        setSInsID(patientId);


      } else if (selectedSearchFilter === 'ins') {
        // Set sInsID to the selected value
        setSInsID(item.val);
        setSPatID(0);

      }
    }


  };









  //Bind the approval table details

  const handleTableDataClick = (e, DataValidationMessage) => {
    console.log("Dropdown Data:", selectAllDropdown);

    setActiveCounts(null)
    setLoading(true);


    var MissingData = DataValidationMessage;

    if (MissingData != "") {
      console.log("Datavalid", MissingData);
    }



    var objInput = {

      iPracticeID: userPracticeID + "",
      sFromDate: startDate,
      sToDate: endDate,
      sFilterType: selectedSearchFilter + "",
      sPatID: sPatID + "",
      sInsID: sInsID + "",
      sDefaultFilter: selectedDropdownValue,
      sLocId: selectLocationID,
      sFilterText: searchText + "",
      sClaimStatus: sClaimStatus || 0,

      LoggedInUserDetails:

      {
        practiceID: userPracticeID

      }
    }
    var objClaim = {
      'objClaim': objInput
    }


    var inputJSON = JSON.stringify(objClaim);
    console.log("input of" + ClaimApprovalConstants.GetApprovalPageClaims, inputJSON);


    const url = `${APIConstants.BASE_URL_BILLING}${ClaimApprovalConstants.GetApprovalPageClaims}?sInputJSON=${inputJSON}`;

    console.log("URL: ", url);

    fetch(url, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    })

      .then((response) => {
        if (response.status != 200) { console.log("response.status", response.status); }
        else return response.json();
      })


      .then((data) => {



        setTableDetails(data)
        console.log("TableData Of " + ClaimApprovalConstants.GetApprovalPageClaims, data);
        setFilteredTableDetails(data);

        setTimeout(() => {
          setLoading(false);

          setDisplayedRecords(data)
        }, 10);


        console.log("FiltertableData of  " + ClaimApprovalConstants.GetApprovalPageClaims, filteredTableDetails);
      })

      .catch((error) => {
        console.error('Error fetching data: ', error);
      });

  }





  const handleDataKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleTableDataClick("");
    }
  };




  useEffect(() => {

    window.addEventListener("keydown", handleDataKeyDown);

    return () => {
      window.removeEventListener("keydown", handleDataKeyDown);
    };
  }, [startDate, endDate, searchText])



  //Fetch the data of GetPracticeClaimStatusCount

  const GetClaimPracticeCount = () => {


    var objInput = {

      iPracticeID: userPracticeID,
      sFromDate: startDate,
      sToDate: endDate,
      sDateFiterType: selectedDropdownValue2,
      sOtherFilterType: selectedSearchFilter,
      sFilterText: userId,
      sCPT: '',
      sLocId: 0



    }



    var objNewInput = {
      'objClaim': objInput
    }
    var sInputJSON = JSON.stringify(objNewInput);


    const url = `${APIConstants.BASE_URL_BILLING}${ClaimApprovalConstants.GetPracticeClaimStatusCount}?sInputJSON=${sInputJSON}`;


    fetch(url, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    })

      .then((response) => {
        if (response.status != 200) { console.log("response.status", response.status); }
        else return response.json();
      })


      .then((data) => {

        const parsedData = JSON.parse(data);
        // const serviceData = parsedData.Data;

        setclaimStatusCount(parsedData)

      })

      .catch((error) => {
        console.error('Error fetching data: ', error);
      });

  }





  const handleAllClick = (e) => {



    handleTableDataClick(e)
    GetClaimPracticeCount();

  }




  useEffect(() => {
    GetClaimPracticeCount();
  }, [])




  const fetchPatientNames = () => {


    var inputJSON = {
      PracticeID: userPracticeID,
      SearchKey: searchText,
      SearchBy: 0,
      isFromLogin: 0
    }

    var sJSONInput = JSON.stringify(inputJSON);

    const url = `${APIConstants.BASE_URL_SEARCH}${CommonAPIConstants.GetAllPatientNames}?sJSONInput=${sJSONInput}`;


    fetch(url, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    })

      .then((response) => {
        if (response.status != 200) { console.log("response.status", response.status); }
        else return response.json();
      })
      .then(data => {



        const parsedData = JSON.parse(data);

        const patientData = parsedData.Data

        if (Array.isArray(patientData)) {
          setSuggestions
            (patientData.map((item) => ({
              label: `${item.LastName}, ${item.FirstName}`,
              val: item.PatientID,
            })));

        } else {


          setSuggestions([]);

          setIsTextBoxDisabled(false);
        }


      })
      .catch((error) => {
        console.error('Error fetching patient names:', error);
      });
  };











  const fetchUpdatedBy = () => {

    var inputStruct = {


      "sPracticeID": userPracticeID,
      "sUserID": userId,
      "srchKey": searchText


    }


    var myInput = { sInputJSON: JSON.stringify(inputStruct) };

    var myInputData = JSON.stringify(myInput);


    const response = fetch(APIConstants.BASE_URL + ClaimApprovalConstants.GetSuggestionDropDowns, {
      method: 'POST',
      headers: {

        'Accept': 'application/json',
        'Content-Type': 'application/json'

      },

      body: myInputData
    })

      .then((response) => response.json())
      .then((data) => {
        // Extract the relevant data from the response

        const parsedData = JSON.parse(data.d);

        const suggestionData = parsedData.Data

        console.log("updatedLists of " + ClaimApprovalConstants.GetSuggestionDropDowns, suggestionData);


        if (suggestionData.length > 0) {
          setSuggestions(suggestionData.map((item) => ({
            label: item.split('$')[1],
            val: item.split('$')[0]
          })));
        } else {
          setSuggestions([]);
          setIsTextBoxDisabled(false);
        }


      })
      .catch((error) => {
        console.error('Error fetching provider names:', error);

      });



  };




  const fetchSubmittedBy = () => {

    var inputStruct = {


      "sPracticeID": userPracticeID,
      "sUserID": userId,
      "srchKey": searchText


    }


    var myInput = { sInputJSON: JSON.stringify(inputStruct) };

    var myInputData = JSON.stringify(myInput);


    const response = fetch(APIConstants.BASE_URL + ClaimApprovalConstants.GetSuggestionDropDowns, {
      method: 'POST',
      headers: {

        'Accept': 'application/json',
        'Content-Type': 'application/json'

      },

      body: myInputData
    })

      .then((response) => response.json())
      .then((data) => {
        // Extract the relevant data from the response

        const parsedData = JSON.parse(data.d);

        const suggestionData = parsedData.Data



        if (suggestionData.length > 0) {
          setSuggestions(suggestionData.map((item) => ({
            label: item.split('$')[1],
            val: item.split('$')[0]
          })));
        } else {
          setSuggestions([]);
          setIsTextBoxDisabled(false);
        }



      })
      .catch((error) => {
        console.error('Error fetching provider names:', error);

      });



  };





  const fetchSearchProviders = () => {

    if (!searchProvidersText) {
      //If searchText is empty, you may want to reset or clear any existing data
      setSearchPatientData([]);
      setIsSuggestionBoxDisabled(true);// Disable suggestion box if needed
      return;
    }



    var inputStruct = {

      "sProviderName": searchText,
      "sPracticeID": userPracticeID,
      "LoggedInUserDetails": userData

    }


    var myInput = { sInputJSON: JSON.stringify(inputStruct) };

    var myInputData = JSON.stringify(myInput);


    const response = fetch(APIConstants.BASE_URL + IntelliBillConstants.GetIntelliProvidersNames, {
      method: 'POST',
      headers: {

        'Accept': 'application/json',
        'Content-Type': 'application/json'

      },

      body: myInputData
    })

      .then((response) => response.json())
      .then((data) => {
        // Extract the relevant data from the response

        const parsedData = JSON.parse(data.d);

        const providersData = parsedData.Data


        if (Array.isArray(providersData)) {
          setSuggestionProviders(providersData.map((item) => ({
            label: (item.split('$')[0]).split('|')[1].trim(),
            val: item.split('$')[1].trim(),
          })));
        } else {
          setSuggestionProviders([]);
        }



      })
      .catch((error) => {
        console.error('Error fetching provider names:', error);

      });
  };





  const fetchInsuranceCompanies = () => {

    var inputJSON = {

      SearchKey: searchText,

    }

    var sJSONInput = JSON.stringify(inputJSON);

    const url = `${APIConstants.BASE_URL_SEARCH}${CommonAPIConstants.GetInsuCompanyNames}?sJSONInput=${sJSONInput}`;


    fetch(url, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    })

      .then((response) => {
        if (response.status != 200) { console.log("response.status", response.status); }
        else return response.json();
      })
      .then(data => {


        const parsedData = JSON.parse(data);

        const InsuranceData = parsedData.Data

        console.log("InsuranceLists of" + CommonAPIConstants.GetInsuCompanyNames, InsuranceData);




        if (Array.isArray(InsuranceData)) {

          const filteredSuggestions = InsuranceData

            .map(item => ({
              label: item.Insurance,
              val: item.InsuID,
            }))




          setSuggestions(filteredSuggestions);

        } else {
          setSuggestions([]);
          setIsTextBoxDisabled(false);
        }

        setIsTextBoxDisabled(false);
      })

      .catch((error) => {
        console.error('Error fetching Insurance names:', error);

      });



  };





  const handleSelectBillingNPI = (event) => {
    const selectedValue = event.target.value;
    setSelectedBillingNPI(selectedValue);

  }


  // const filteredProviders = practiceProvider.filter(provider => provider.Supervisor === '1' || provider.Supervisor === '3');

  const handleSelectFilterProviders = (event) => {
    const selectedValue = event.target.value;
    setSelectedFilterProvider(selectedValue);

  }



  const [selectedProvider, setSelectedProvider] = useState('');
  const [tdata, setTdata] = useState('');





  // Function to handle checkbox change
  const handleCheckboxChange = (e) => {
    const value = e.target.checked ? 1 : 0; // Set 1 if checked, 0 if unchecked
    setIsChecked(value);
  };






  const processTableData = () => {
    tableDetails.forEach((item) => {

      setRowsValidation(item.DataValidationMessage);
    });
  };





  useEffect(() => {



    if (selectedRecValue === 'all') {
      setDisplayedRecords(filteredTableDetails);
    } else {
      setDisplayedRecords(filteredTableDetails.slice(0, selectedRecValue));
    }
  }, [filteredTableDetails, selectedRecValue]);




  useEffect(() => {
    if (displayedRecords && Array.isArray(displayedRecords)) {
      setTotalRecords(displayedRecords.length);
    } else {
      setTotalRecords(0);
    }
  }, [displayedRecords]);




  const handleSelectChange = (e) => {
    const value = e.target.value;
    setSelectedRecValue(value);
  };



  const convertDateFormat = (dateString) => {
    const [year, month, day] = dateString.split('-');
    return `${month}/${day}/${year}`;
  };










  const convertTimestampToDate = (timestamp) => {
    return new Date(parseInt(timestamp.substr(6)));


  }




  const filterTableData = () => {

    const filteredData = tableDetails.filter((item) => {

      return (
        item[selectedSearchFilter].toLowerCase().includes(searchText.toLowerCase())
      );
    });


    setTableDetails(filteredData);
  };



  const handleRowCheckboxChange = (index) => {
    if (selectedRows.includes(index)) {
      setSelectedRows(selectedRows.filter((selectedRow) => selectedRow !== index));
    } else {
      setSelectedRows([...selectedRows, index]);
    }
  };

  const handleSelectAllChange = () => {
    const allSelected = tableDetails.every((_, index) => selectedRows.includes(index));

    if (allSelected) {
      // Deselect all checkboxes
      setSelectedRows([]);
    } else {
      // Select all checkboxes
      setSelectedRows(Array.from({ length: tableDetails.length }, (_, index) => index));
    }
  };

  // New function to update "Select All" checkbox state based on individual checkboxes
  const updateSelectAllCheckbox = () => {
    const allSelected = tableDetails.every((_, index) => selectedRows.includes(index));
    const someSelected = selectedRows.length > 0 && !allSelected;

    // Update the "Select All" checkbox based on individual checkboxes
    setSelectAllChecked(allSelected);
    setSelectAllIndeterminate(someSelected);
  };

  // State for "Select All" checkbox
  const [selectAllChecked, setSelectAllChecked] = useState(false);
  const [selectAllIndeterminate, setSelectAllIndeterminate] = useState(false);

  // Use useEffect to update "Select All" checkbox state whenever selectedRows changes
  useEffect(() => {
    updateSelectAllCheckbox();
  }, [selectedRows]);

  // Render the "Select All" checkbox with its checked and indeterminate state
  // You can use selectAllChecked for the 'checked' prop and selectAllIndeterminate




  const handleSendSelectAllChange = () => {
    const allSelected = tableDetails.every((_, index) => selectedSendRows.includes(index));

    if (allSelected) {
      // Deselect all checkboxes
      setSelectedSendRows([]);
    } else {
      // Select all checkboxes
      setSelectedSendRows(Array.from({ length: tableDetails.length }, (_, index) => index));
    }


  };



  const handleSendRowCheckboxChange = (index) => {

    if (selectedSendRows.includes(index)) {
      setSelectedSendRows(selectedSendRows.filter((selectedRow) => selectedRow !== index));
    } else {
      setSelectedSendRows([...selectedSendRows, index]);
    }

  }










  const handleSelectLocationAllChange = () => {
    const allSelected = tableDetails.every((_, index) => selectedLocationRows.includes(index));

    if (allSelected) {
      // Deselect all checkboxes
      setSelectedLocationRows([]);
      handleSelectAllChange([]);
    } else {
      // Select all checkboxes
      setSelectedLocationRows(Array.from({ length: tableDetails.length }, (_, index) => index));

      handleSelectAllChange();

      console.log("selectedServiceLocationrows", selectedLocationRows);
    }
  };



  const handleLocRowCheckboxChange = (index) => {
    if (selectedLocationRows.includes(index)) {
      setSelectedLocationRows(selectedLocationRows.filter((selectedRow) => selectedRow !== index));
    } else {
      setSelectedLocationRows([...selectedLocationRows, index]);
    }

  }








  const handleUnitChargeAllChange = () => {
    const allSelected = tableDetails.every((_, index) => UnitChargeRows.includes(index));

    if (allSelected) {
      // Deselect all checkboxes
      setUnitChargeRows([]);
      handleSelectAllChange([]);
    } else {
      // Select all checkboxes
      setUnitChargeRows(Array.from({ length: tableDetails.length }, (_, index) => index));

      handleSelectAllChange();

    }
  };









  const handleSelectProviderAllChange = () => {
    const allSelected = tableDetails.every((_, index) => providerAllCheckbox.includes(index));

    if (allSelected) {
      // Deselect all checkboxes
      setProviderAllCheckbox([]);
      handleSelectAllChange([]);
    } else {
      // Select all checkboxes
      setProviderAllCheckbox(Array.from({ length: tableDetails.length }, (_, index) => index));

      handleSelectAllChange();


    }
  };


  const handleProviderRowCheckboxChange = (index) => {
    if (providerAllCheckbox.includes(index)) {
      setProviderAllCheckbox(providerAllCheckbox.filter((selectedRow) => selectedRow !== index));



    } else {
      setProviderAllCheckbox([...providerAllCheckbox, index]);


    }
  };









  const handleOpenModal = () => {
    if (selectedSendRows.length === 0) {
      // Show error modal if no rows are selected



      setShowSelectErrorModal(true);
    } else {
      // Show confirm save modal if rows are selected

      setShowConfirmSaveModal(true);
    }
  };




  const handleOpenApprovalModal = () => {
    if (selectedRows.length === 0) {
      // Show error modal if no rows are selected



      setShowSelectErrorModal(true);
    } else {
      // Show confirm save modal if rows are selected

      setShowApprovalSaveModal(true);
    }
  };

  const handleCloseClaimModal = () => {

    setCloseClaimsModal(true);

  }




  const handleCloseModals = () => {
    // Close all modals
    setShowSelectErrorModal(false);
    setShowConfirmSaveModal(false);
    setShowSuccessModal(false);
    setShowDeleteModal(false);
    setShowApprovalSaveModal(false);
    setCloseClaimsModal(false);
    setShowFaxModal(false);
    setIsEPINVerifiedModal(false);
    setShowAttachmentData(false)
  };


  const handleOpenDeleteModal = () => {
    setEpin("")
    if (selectedRows.length === 0) {


      setShowSelectErrorModal(true);
    } else {


      setShowDeleteModal(true);
    }
  };













  const handleClearinghouseChange = (index, e) => {
    const selectedValue = e.target.value;
    setClearingHouse(selectedValue)


    const updatedRows = [...filteredTableDetails];
    updatedRows[index].ClearingHouse = selectedValue;

    // Set the updated state
    setFilteredTableDetails(updatedRows);



  };






  useEffect(() => {

    console.log("ClearingHouse", ClearingHouse);
  }, []);





  const handleAllClearingHouse = () => {





    var inputStruct = {


      "sPracticeID": userPracticeID,

    }


    var myInput = { sInputJSON: JSON.stringify(inputStruct) };

    var myInputData = JSON.stringify(myInput);


    const response = fetch(APIConstants.BASE_URL + CommonAPIConstants.GetAllclearingHouse, {
      method: 'POST',
      headers: {

        'Accept': 'application/json',
        'Content-Type': 'application/json'

      },

      body: myInputData
    })

      .then((response) => response.json())
      .then((data) => {
        // Extract the relevant data from the response


        const parsedData = JSON.parse(data.d);

        const allClearingHouseData = parsedData.Data

        setSelectClearingHouse(allClearingHouseData);



      })
      .catch((error) => {
        console.error('Error fetching All clearing house:', error);
      });
  };




  useEffect(() => {

    handleAllClearingHouse();

  }, []);










  //Send to Clearing House functionality



  const SendToClearingHouse = async (e, isSaveforApproval) => {


    const selectedDataArray = [];

    for (const rowIndex of selectedSendRows) {
      const item = tableDetails[rowIndex];


      var mod3 = item.Mod3
      if (mod3 == null) {
        mod3 = ""
      }


      var mod2 = item.Mod2
      if (mod2 == null) {
        mod2 = ""
      }

      var mod1 = item.Mod1
      if (mod1 == null) {
        mod1 = ""
      }



      var diag1 = item.ICDCode
      if (diag1 == null) {
        diag1 = ""
      }


      var diag2 = item.ICDCode2
      if (diag2 == null) {
        diag2 = ""
      }



      const selectedData = {

        "PracticeID": userPracticeID + "",
        "PatientID": item.PatientID + "",
        "ClaimID": item.ClaimId,
        "DOS": formatDOSDate(item.AppointmentDate) + "",
        "EncounterID": item.Encounter + "",
        "PatientName": item.FirstName + item.LastName + "",
        "isPriorSecClaim": item.PriorSecClaim + "",
        "Status": item.Status + "",
        "iClearingHouse": item.ClearingHouse,
        "userId": userId,
        "userpracticeId": userPracticeID

      }


      selectedDataArray.push(selectedData)


    }
    e.preventDefault();

    var myInput = JSON.stringify({ objClaim: selectedDataArray });

    myInput = JSON.stringify(myInput);


    try {


      const response = await fetch(APIConstants.BASE_URL_BILLING + ClaimApprovalConstants.SaveApprovalClaims, {
        method: 'POST',


        headers: {

          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${sAuthToken}`

        },

        body: myInput
      })


      if (response.ok) {
        const responseData = await response.json();


        // const parsedData = JSON.parse(responseData.d);

        setUpdatedTableData(responseData)

        setShowSelectErrorModal(false);
        setShowConfirmSaveModal(false);
        setShowApprovalSaveModal(false);

        // Show the success modal after saving changes



        setShowSuccessModal(true);

        setSavedRowCount(selectedSendRows.length);

        handleTableDataClick()

      } else {
        console.error('Error sending data to the API');
        setSavedRowCount(savedRowCount + selectedSendRows.length);

      }


      setSelectedSendRows([]);


    } catch (error) {
      console.error('An error occurred:', error);

    }

  }











  const handleGetVerifiedEPIN = (enteredEpin) => {


    var sInputJSON = {
      UserID: userData.userID,
      EPIN: epin


    }


    var sJSONInput = JSON.stringify(sInputJSON);

    const url = `${APIConstants.SERVICES_URL}${IntelliBillConstants.GetVerifyEPIN}?sInputJSON=${sJSONInput}`;


    fetch(url, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    })

      .then((response) => {
        if (response.status != 200) { console.log("response.status", response.status); }
        else return response.json();
      })
      .then(data => {



        //  const parsedData = JSON.parse(data);


        setverifiedEpin(data)

        if (data === 1) {

        }


      })
      .catch((error) => {
        console.error('Error fetching :', error);
      });
  };






  const handleEpinChange = (e) => {
    e.preventDefault()

    const enteredEpin = e.target.value;
    setEpin(enteredEpin);

  };




  const [showPassword, setShowPassword] = useState(false);

  const handleTogglePassword = () => {
    setShowPassword(!showPassword);
  };







  const handleDelete = async (isPermanent) => {



    if (!verifiedEpin && verifiedEpin !== 0) {

      return;
    }





    if (verifiedEpin === 0) {

      setIsEPINVerifiedModal(true)
      return;
    }


    const objClaim = [];

    for (const rowIndex of selectedRows) {
      const item = tableDetails[rowIndex];



      const patientName = `${item.LastName},${item.FirstName}`



      const selectedData = {

        PracticeID: userPracticeID,
        PatientID: item.PatientID + "",
        ClaimID: item.ClaimId,
        EncounterID: 0,
        PatientName: patientName,
        DOS: formatDOSDate(item.AppointmentDate),
        IsDeletePermanently: isPermanent,
        UserID: userId,
        UserFullName: userData.userFullName



      }


      objClaim.push(selectedData)


    }

    var myInput = JSON.stringify({ objClaim: objClaim });


    var InputJson = JSON.stringify(myInput);


    try {



      const response = await fetch(APIConstants.BASE_URL_BILLING + CommonAPIConstants.DeleteClaim, {
        method: 'POST',


        headers: {

          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${sAuthToken}`

        },

        body: InputJson
      })


      if (response.ok) {
        const responseData = await response.json();
        setShowDeleteModal(false)

        setUpdatedTableData(responseData)


        setShowDeleteModal(false);

        setDeleteRowCount(selectedRows.length);

        setDeleteSuccessModal(true)


        setDisplayedRecords(prevTableDetails =>
          prevTableDetails.filter((_, index) => !selectedRows.includes(index))
        );


        setSelectedRows([]);

        setEpin("");



      } else {
        console.error('Error sending data to the API');
        setDeleteRowCount(deleteRowCount + selectedRows.length);

      }

    } catch (error) {
      console.error('An error occurred:', error);

    }


  };






  useEffect(() => {
    setEpin("");

    const filteredData = tableDetails.filter((item) => {
      return (
        (!searchByPatient || (item.LastName?.toLowerCase().includes(searchByPatient.toLowerCase()))) &&

        (!searchByDOS || (formatDOSDate(item.AppointmentDate)?.toLowerCase().includes(searchByDOS.toLowerCase()))) &&
        (!searchByDOB || (formatDOSDate(item.DOB)?.toLowerCase().includes(searchByDOB.toLowerCase()))) &&
        (!searchByInsurance || (item.Payer?.toLowerCase().includes(searchByInsurance.toLowerCase()))) &&
        (!searchByClaim || ((item.ClaimId ?? "").toString().toLowerCase().includes(searchByClaim.toLowerCase()))) &&
        (!searchByProvider || (item.RenderingProvider?.toLowerCase().includes(searchByProvider.toLowerCase()))) &&
        (!searchByCPT || (item.EncCPT?.toLowerCase().includes(searchByCPT.toLowerCase()))) &&
        (!searchByICD || (item.EncICD?.toLowerCase().includes(searchByICD.toLowerCase()))) &&
        (!searchByModifier || (item.EncModifier?.toLowerCase().includes(searchByModifier.toLowerCase()))) &&
        (!searchByTotalCharge || ((item.ClaimTotalSubmitedCharge ?? "").toString().toLowerCase().includes(searchByTotalCharge.toLowerCase()))) &&
        (!searchByStatus || (item.ClaimStatus?.toLowerCase().includes(searchByStatus.toLowerCase()))) &&
        (!searchByRecievedCharge || ((item.ReceivedCharge ?? "").toString().startsWith(searchByRecievedCharge))) &&
        (!searchByPostingDate || (formatSubmitDate(item.PostingDate)?.toLowerCase().includes(searchByPostingDate.toLowerCase()))) &&
        (!searchBySubmitdate || (formatSubmitDate(item.SubmitDate)?.toLowerCase().includes(searchBySubmitdate.toLowerCase()))) &&
        (!searchByUpdatedBy || (item.UpdatedBy?.toLowerCase().includes(searchByUpdatedBy.toLowerCase()))) &&
        (!searchBySubmitter || (item.SubmittedBy?.toLowerCase().includes(searchBySubmitter.toLowerCase())))
      );
    });

    setDisplayedRecords(searchByDOS || searchByPatient || searchByDOB || searchByInsurance || searchByClaim || searchByProvider || searchByPostingDate || searchByUpdatedBy || searchBySubmitter
      || searchByCPT || searchByTotalCharge || searchByICD || searchByModifier || searchByTotalCharge || searchByStatus || searchByRecievedCharge || searchBySubmitdate
      ? filteredData : filteredTableDetails);

  }, [searchByDOS, searchByPatient, searchByDOB, searchByInsurance, searchByClaim, searchByProvider, searchByCPT, searchByICD, searchByModifier, searchByUpdatedBy, searchBySubmitter,
    searchByTotalCharge, searchByStatus, searchByRecievedCharge, searchBySubmitdate, searchByPostingDate, filteredTableDetails]);





  useEffect(() => {
    localStorage.removeItem("searchBySubmitter");
    sessionStorage.removeItem("searchBySubmitter");
    setSearchBySubmitter("");
  }, []);




  useEffect(() => {
    setSearchBySubmitter("");
  }, []);



  const formatAppointMentDate = (dateString) => {
    const timestamp = parseInt(dateString.match(/\d+/)[0], 10);
    const date = new Date(timestamp);

    if (isNaN(date.getTime())) {
      return '';
    }
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${month}/${day}/${year}`;
  };


  const formatDOSDate = (dateString) => {
    if (!dateString) {
      return "";  // Return empty string if dateString is null or empty
    }

    const date = new Date(dateString);


    if (isNaN(date)) {
      return "";  // Return empty string if the date is invalid
    }

    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit"
    });
  };






  const formatSubmitDate = (dateString) => {
    if (!dateString) {
      return ""; // or any default value you want to display for null dates
    }

    const date = new Date(dateString);

    if (isNaN(date.getTime())) {
      return "Invalid Date"; // handle cases where the date string is not valid
    }

    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
  };





  function getRecievedChargeClass(recievedCharge) {
    if (recievedCharge === 0) {
      return 'nonpaid-claims';
    } else if (recievedCharge > 0) {
      return 'paid-claims';
    } else {
      return '';
    }


  }



  const handleRowClick = (index) => {
    setActiveRow(index);
  };









  const fetchGetAllEvents = (item) => {

    setselectedClaimID(item.ClaimId)


    var inputJSON = {
      PracticeID: userPracticeID,
      ModuleName: "Billing",
      dtFromDate: startDate,
      dtToDate: endDate,
      DataID: item.ClaimId,
      UserID: 0,
      DateType: "DOS",

    }

    var sInputJSON = JSON.stringify(inputJSON);


    const url = `${APIConstants.COMMON_BASE_URL}${CommonAPIConstants.GetClaimAllEvents}?sJSONInput=${sInputJSON}`;

    console.log("URL: ", url);

    fetch(url, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    })

      .then((response) => {
        if (response.status != 200) { console.log("response.status", response.status); }
        else return response.json();
      })
      .then(data => {



        const parsedData = JSON.parse(data);

        const patientData = parsedData.Data

        setEventData(patientData)

        setShowFaxModal(true)


      })
      .catch((error) => {
        console.error('Error fetching patient names:', error);
      });
  };







  const handleSelectInsuranceAllChange = () => {



    const allSelected = tableDetails.every((_, index) => insuranceAllCheckbox.includes(index));

    if (allSelected) {
      // Deselect all checkboxes
      setInsuranceAllCheckbox([]);

    } else {
      // Select all checkboxes
      setInsuranceAllCheckbox(Array.from({ length: tableDetails.length }, (_, index) => index));


    }
  };


  const handleInsuranceRowCheckbox = (index, item) => {

    setClaimID(item.ClaimId)


    if (insuranceAllCheckbox.includes(index)) {
      // If the row is already selected, unselect it
      setInsuranceAllCheckbox(insuranceAllCheckbox.filter((selectedRow) => selectedRow !== index));

    } else {
      // If the row is not selected, select it
      setInsuranceAllCheckbox([...insuranceAllCheckbox, index]);

    }
  };


  //Checkeligibility functionality


  const handleCheckeligibility = async (e, rowIndex) => {

    if (insuranceAllCheckbox.length == 0) {
      setShowSelectErrorModal(true)
      return;
    }


    setRowState((prevState) => ({
      ...prevState,
      [claimID]: { isLoading: true, isHidden: true, showIcon: true }
    }));



    const selectedDataArray = [];

    for (const rowIndex of insuranceAllCheckbox) {
      const item = filteredTableDetails[rowIndex] || filteredTableDetails[rowIndex];
      setClaimID(item.ClaimId

      );
      setShowSelectErrorModal(false)

      setIsLoading(true);

      const eligibilityDOS = formatDOSDate(item.AppointmentDate);


      var InsCountryId = item.PrimaryIns
      if (InsCountryId == null) {
        InsCountryId = ""
      }

      var PayerID = item.InsPayerID
      if (PayerID == null) {
        PayerID = ""
      }



      var inputStruct = {

        "PatientID": item.PatientID,
        "PracticeID": userPracticeID,
        "PolicyNumber": item.PolicyNumber + "",
        "DOS": eligibilityDOS,
        "RowIndex": rowIndex


      };
    }


    var objPatientDetails = {
      'objPatientDetails': inputStruct
    }
    var myInput = JSON.stringify(objPatientDetails);

    var myInput = JSON.stringify(objPatientDetails);
    const url = `${APIConstants.PATIENT_PORTAL_URL}${CommonAPIConstants.GetPatientEligibility}?sInputJSON=${myInput}`;

    console.log("URL: ", url);

    fetch(url, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    })

      .then((response) => {
        if (response.status != 200) { console.log("response.status", response.status); }
        else return response.json();
      })


      .then((data) => {


        const responseData = data
        const parsedData = JSON.parse(responseData);


        setRowState((prevState) => ({
          ...prevState,
          [claimID]: { isLoading: false, isHidden: false, showIcon: true },
        }));


        setCheckEligibility(parsedData)

        var RowIndex = parsedData.RowIndex;
        var InsStatus = parsedData.InsStatus;
        setIsInStatus(parsedData.InsStatus);
        var EligibilityError = parsedData.EligibilityError;




        const payerIDElement = document.querySelector(`.payer${RowIndex}`);


        const filteredClaims = filteredTableDetails.filter((item) => {
          if (item.ClaimId == claimID) {
            if (payerIDElement) {
              if (parsedData.InsStatus === "Active") {
                payerIDElement.style.color = 'green';
              } else {
                payerIDElement.style.color = 'red';
              }
            }
          }


          return true;
        });

        setFilteredTableDetails(filteredClaims);






      }).catch((error) => {
        console.error('An error occurred:', error);

        setRowState((prevState) => ({
          ...prevState,
          [claimID]: { isLoading: false, isHidden: false, showIcon: true },
        }));



      })

  }





  const handlePrint = () => {
    if (!tableRef.current) {
      console.error("Table reference is not set.");
      return;
    }



    setVisibleRecords(displayedRecords.length);
    const prevVisibleCount = visibleRecords;

    setTimeout(() => {
      const tableHTML = tableRef.current.outerHTML;
      const printWindow = window.open("", "_blank");

      printWindow.document.writeln(`
      <html>
        <head>
          <title class="print-title">Approval</title>
          <style>
            body {
              font-family: Arial, sans-serif;
              margin: 10px;
              font-size: 15px;
              color: #000;
            }

            .print-title {
              text-align: center;
              font-size: 24px;
              font-weight: bold;
              margin-bottom: 20px;
              color: #0173b7;
            }

            .table-container {
              width: 100%;
              overflow-x: auto;
            }

            table {
              width: 100%;
              border-collapse: collapse;
              table-layout: auto; 
              word-wrap: break-word;
            }

            th, td {
              border: 1px solid black;
              padding: 5px;
              text-align: left;
              font-size: 15px;
            }

            th {
              background-color: #f4f4f4;
              color: white;
              border: 1px solid black;
            }

            td {
              font-size: 14px;
            }

            @media print {
              @page {
                size: A3 landscape;
                margin: 10mm;
              }

              .table-container {
                overflow: visible !important;
              }

              .hide-on-print {
                display: none !important;
              }


              
              .show-icon{
                 font-size: 5px;
                 width: 10px;
                    
                }
              
              .input{
                width: 60px;
                color: black;
              }

              .name{
                  display: inline-block;
                    max-width: 40px !important; 
                    word-wrap: break-word;
                    white-space: normal !important;
                    overflow-wrap: break-word;
                    font-size: 14px;
                }

              .print-label {

                   display: inline-block;
                    max-width: 40px; 
                    word-wrap: break-word;
                    white-space: normal !important;
                    overflow-wrap: break-word;
                    font-size: 12px;
                 }

              .doc{
                
                 font-size: 10px;
              }
            }

            body {
              -webkit-print-color-adjust: exact;
            }
          </style>
        </head>
        <body>
          <div class="table-container">${tableHTML}</div>
          <script>
            window.onload = function() {
              window.print();
            };
            window.onafterprint = function() {
              window.close();
            };
          </script>
        </body>
      </html>
    `);

      printWindow.document.close();


      setTimeout(() => {
        setVisibleRecords(prevVisibleCount);
      }, 10);
    }, 10);
  };








  const tableRef = useRef('');
  const formatInsuranceCell = (item) => {
    const isSecondary = !!item.SecPayerID;
    const payer = isSecondary ? item.SecPayer : item.Payer;
    const payerId = isSecondary ? item.SecPayerID : item.PayerID;
    const policy = isSecondary ? item.SecInsPolicyNumber : item.PolicyNumber;
    // const status = item.PatInsStatus === "Active" ? "Active" : "Inactive";
    // const skipped = item.IsPrimarySkipped ? "Yes" : "No";

    return `${payer || ""}
${payerId || ""}
${policy || ""}`;
  };
  const getClearingHouseName = (id) => {
    const found = selectClearinghouse.find(n => n.MCHID == id);
    return found ? found.ClearingHouseName : "";
  };
  const exportToExcel = () => {
    const data = displayedRecords.slice(0, tableDetails?.length).map((item, index) => ({
      "#": index + 1,
      Location: item.LocationNickname || "",
      DOS: formatDOSDate(item.AppointmentDate) || "",
      "Patient Name": `${item.LastName || ""}, ${item.FirstName || ""}`,
      DOB: formatDOSDate(item.DOB) || "",
      Insurance: formatInsuranceCell(item),
      "Status": item.ClaimStatus || "",
      "Claim #": item.ClaimId || "",
      Provider: item.RenderingProvider || "",
      CPT: item.EncCPT ? item.EncCPT.replace(/^,/, "") : "",
      ICD: item.EncICD || "",
      Modifier: item.EncModifier || "",
      "Total Charge": item.ClaimTotalSubmitedCharge ? `$${item.ClaimTotalSubmitedCharge}` : "",
      "Posting Date": formatSubmitDate(item.PostingDate) || "",
      "Submit Date": item.IsPrimarySkipped
        ? formatSubmitDate(item.SecClaimSubmiDate)
        : formatSubmitDate(item.SubmitDate),
      "Received Charge": item.ReceivedCharge || "",
      "Clearing House": getClearingHouseName(item.ClearingHouse) || "",
      "Send":
        !(
          item.ClaimStatusInt === "" ||
          item.ClaimStatusInt === null ||
          item.ClaimStatusInt == 0 ||
          item.ClaimStatusInt == 6 ||
          item.ClaimStatusInt == 8
        )
          ? "Yes"
          : "No",
      "Updated By": item.UpdatedBy || "",
      "Submitted By": item.SubmittedBy || "",
      "Attachments": item.Attachments || "",
      Validate: "Yes",
    }));
    exportExcel(data, "Approval", "Approval")
  };






  const exportToPDF = () => {
    const pagename = "Claim Approval";
    setVisibleRecords(filteredTableDetails.length);

    const prevVisibleCount = visibleRecords;

    setTimeout(() => {
    const table = tableRef.current.parentNode;
    let sPrintableData = table ? table.innerHTML : '';

    const container = document.createElement('div');
    container.innerHTML = sPrintableData;
    container.querySelectorAll('.hide-on-print').forEach(el => el.remove());

    sPrintableData = container.innerHTML;


    const vRegEx = new RegExp("gvClosedClaims", "");
    sPrintableData = sPrintableData.replace(vRegEx, "gvAcceptdClaims");


    const PrintableDataDetails = {
      PrintableData: sPrintableData,
      PageName: pagename,
    };

    const InputJSONLevelOne = JSON.stringify(PrintableDataDetails);
    const InputJSON = JSON.stringify(InputJSONLevelOne);


    fetch(APIConstants.SERVICES_URL + FilesAPIConstants.ExportPdfFile, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: InputJSON,
    })
      .then(response => response.json()) // Parse the response as JSON
      .then(data => {


        if (data && data[2]) {

          const url = data[2];
          window.open(url, '_blank');


        }
      })
      .catch(err => console.error('Export to PDF failed', err))
        .finally(() => {

          setVisibleRecords(prevVisibleCount);
        });

    }, 100);
  };





  const GetPDFCMS = (item) => {


    const claimFilters = {

      PracticeID: userPracticeID,
      ClaimID: item.ClaimId,
      PatientID: item.PatientID,

    };


    const sInputJSON = JSON.stringify(claimFilters);



    const url = `${APIConstants.BASE_URL_BILLING}${CommonAPIConstants.GetPDFCMS1500}?sInputJSON=${sInputJSON}`;

    console.log("URL: ", url);

    fetch(url, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    })

      .then(response => response.json()) // Parse the response as JSON
      .then(data => {

        if (data && data) {

          const parsedData = JSON.parse(data);
          const url = parsedData.DocumentURL
          window.open(url, '_blank');


        }
      })
      .catch(error => {
        console.error(' PDF failed', error);
      });
  };



  const handleRegeneratePDFCMS = (item) => {
    const { ClaimId } = item;


    setRowState((prevState) => ({
      ...prevState,
      [ClaimId]: { isLoading: true, isHidden: false }
    }));


    const objInput = {
      PatientID: item.PatientID,
      ClaimID: item.ClaimId,
      PracticeID: userPracticeID,
      PriorSecClaim: item.PriorSecClaim,
      UserTimeZoneOffSet: 300,
      UserID: userId
    };


    const sInputJSON = JSON.stringify({ objClaim: objInput });

    const url = `${APIConstants.BASE_URL_BILLING}${CommonAPIConstants.SaveRegeneratePDFCMS1500}?sInputJSON=${sInputJSON}`;

    console.log("URL: ", url);

    fetch(url, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',

      }
    })

      .then((response) => response.json())
      .then((data) => {


        setReGenerateData(data);

        setRowState((prevState) => ({
          ...prevState,
          [ClaimId]: { isLoading: false, isHidden: true },
        }));
      })
      .catch((error) => {
        console.error('An error occurred:', error);


        setRowState((prevState) => ({
          ...prevState,
          [ClaimId]: { isLoading: false, isHidden: false },
        }));
      });
  };





  const handleDosLinkClick = (item) => {
    const claimId = item.ClaimId;

    localStorage.setItem('selectedClaimItem', JSON.stringify(item));

    const url = `/#/transactionlogs/${claimId}`;
    window.open(url, '_blank');
  };


  const handlePatLinkClick = (item) => {
    const url = `/#/patient-dashboard/${item.PatientID}/primary-insurance`;

    localStorage.setItem("PatientID", item.PatientID);

    window.open(url, '_blank');
  };


  const handleLinkClick = (item) => {
    const url = `/#/new-encounter/${item.ClaimId}`;
    window.open(url, '_blank');
  };



  const handleSort = (key, accessor) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }

    const sortedData = [...displayedRecords].sort((a, b) => {
      let aValue = accessor ? accessor(a) : a[key];
      let bValue = accessor ? accessor(b) : b[key];


      if (aValue == null) aValue = 0;
      if (bValue == null) bValue = 0;


      if (key.toLowerCase().includes('date') || key.toLowerCase().includes('dob') || key.toLowerCase().includes('dos')) {
        aValue = new Date(aValue);
        bValue = new Date(bValue);
      }

      else if (!isNaN(aValue) && !isNaN(bValue)) {
        aValue = parseFloat(aValue) || 0;
        bValue = parseFloat(bValue) || 0;
      }

      else if (typeof aValue === 'string') {
        aValue = aValue.toUpperCase();
        bValue = typeof bValue === 'string' ? bValue.toUpperCase() : '';
      }

      if (aValue < bValue) return direction === 'asc' ? -1 : 1;
      if (aValue > bValue) return direction === 'asc' ? 1 : -1;
      return 0;
    });

    setSortConfig({ key, direction });
    setDisplayedRecords(sortedData);
  };





  //Get all table data based on totalStatus Records
  const ReloadClaimsData = (filterType, isTotal, claimDOS) => {
    setLoading(true);

    console.log("FILTERING ", filterType);
    console.log("isTotal ", isTotal);
    setDisplayedRecords([]);
    const filteredClaimsData = tableDetails.filter((claim) => {


      const curDOS = formatDOSDate(claim["ClaimDOS"]);
      const submitDate = formatSubmitDate(claim.SubmitDate);
      const SecClaimSubmiDate = formatSubmitDate(claim.SecClaimSubmiDate);
      const recvdCharge = claim.recvdCharge;



      if (!isTotal && curDOS === claimDOS) {
        {
          switch (filterType) {
            case 'all':
              return true;
            case 'submit':
              return (submitDate !== "" || SecClaimSubmiDate !== "");
            case 'nonsubmit':
              return (submitDate === "" && SecClaimSubmiDate === "");
            case 'sent':
              return claim["ClaimStatusInt"] == 3;
            case 'pending':
              return claim["ClaimStatusInt"] == 4;
            case 'paid':
              return claim["ClaimStatusInt"] == 1 && claim["isDenied"] == 0 && recvdCharge > 0;
            case 'rejected':
              return claim["ClaimStatusInt"] == 2;
            case 'denied':
              return claim["isDenied"] === 1;
            case 'recvd':
              return claim["isPaymentReceived"];
            case 'posted':
              return claim["isPaymentPosted"];
            default:
              return false;
          }
        }
      } else {
        switch (filterType) {
          case 'all':
            return true;
          case 'submit':
            return (submitDate !== "" || SecClaimSubmiDate !== "");
          case 'nonsubmit':
            return (submitDate === "" && SecClaimSubmiDate === "");
          case 'sent':
            return claim["ClaimStatusInt"] == 3;
          case 'pending':
            return claim["ClaimStatusInt"] == 4;
          case 'paid':
            return claim["ClaimStatusInt"] == 1 && claim["isDenied"] == 0 && recvdCharge > 0;
          case 'rejected':
            return claim["ClaimStatusInt"] == 2;
          case 'denied':
            return claim["isDenied"] === 1;
          case 'recvd':
            return claim["isPaymentReceived"];
          case 'posted':
            return claim["isPaymentPosted"];
          default:
            return false;
        }
      }
    });

    setTimeout(() => {
      setLoading(false);
      setDisplayedRecords(filteredClaimsData);
    }, 500);

    console.log("filteredClaimsData", filteredClaimsData);
  };


  const handleClaimCountsClick = (rowKey) => {
    setActiveCounts(rowKey);
  };






  const handleGetClaimAttachments = async (item) => {


    setattachmentClaimID(item.ClaimId)
    var objInput = {

      ClaimID: item.ClaimId,
      PracticeID: userData.practiceID,

    }

    var sInputJSON = JSON.stringify(objInput);


    const url = `${APIConstants.BASE_URL_BILLING}${CommonAPIConstants.GetClaimAttachments}?sInputJSON=${sInputJSON}`;

    console.log("URL: ", url);

    fetch(url, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',

      }
    })

      .then((response) => {
        if (response.status != 200) { console.log("response.status", response.status); }
        else return response.json();
      })
      .then(data => {
        console.log("Response Attachment", data);

        setAttachmentData(data);
        setShowAttachmentData(true)
      })
      .catch((error) => {
        console.error('Error fetching:', error);
      });
  }





  const GetDOCPDF = (doc) => {
    window.open(doc, '_blank');

  };


  return (
    <>



      <div className='main-container'>
        <div className='container-style'>

          <div className='topnavmenu'>
            <label className='active-label'>Claim  Approval</label>
          </div>

          <div className='searchfilter-container'>


            <div className='searchfilter-style'>
              <div className='date-container'>


                <div>


                  <select name="select" style={{ height: '25px', height: '30px' }}
                    value={selectedDropdownValue}
                    onChange={(e) => {
                      const selectedValue = e.target.value;
                      setSelectedDropdownValue(selectedValue);
                      setSelectedDropdownValue2(convertValueToNumber(selectedValue));
                    }}
                  >

                    <option value="AppointmentDate" >DOS</option>
                    <option value="PostingDate" >To Approve</option>
                    <option value="SubmitDate" >Submit Date</option>
                  </select>

                </div>



                <div className="datepicker-container" style={{ marginLeft: '5px', zIndex: 10 }}>
                  <label>From:</label>
                  <DatePicker
                    selected={startDate ? new Date(startDate) : null}
                    onChange={handleStartDateChange}
                    dateFormat="MM/dd/yyyy"
                    maxDate={new Date()}
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    yearDropdownItemNumber={100}
                    readOnly={isHideChecked}
                    className={`clnImgTextBoxes ${startDate ? 'default-selected' : ''}`}
                    placeholderText="MM/dd/yyyy"


                    calendarContainer={CalendarStartContainer}
                    open={isStartOpen}
                    onFocus={() => setIsStartOpen(true)}
                    onInputClick={() => setIsStartOpen(true)}
                    onClickOutside={() => setIsStartOpen(false)}
                    renderCustomHeader={({ date, changeYear, changeMonth, decreaseMonth, increaseMonth, prevMonthButtonDisabled, nextMonthButtonDisabled }) => {
                      const selectedDate = date instanceof Date && !isNaN(date) ? date : new Date();
                      const selectedMonth = selectedDate.getMonth();
                      const selectedYear = selectedDate.getFullYear();

                      return (
                        <div>
                          <button onClick={decreaseMonth} disabled={prevMonthButtonDisabled} style={{ height: '25px' }}>
                            {"<"}
                          </button>
                          <select
                            value={selectedMonth}
                            onChange={({ target: { value } }) => changeMonth(Number(value))}
                          >
                            {getMonths(selectedYear)}
                          </select>
                          <select
                            value={selectedYear}
                            onChange={({ target: { value } }) => changeYear(Number(value))}
                          >
                            {Array.from({ length: 100 }, (v, k) => (
                              <option key={k} value={new Date().getFullYear() - k}>
                                {new Date().getFullYear() - k}
                              </option>
                            ))}
                          </select>
                          <button onClick={increaseMonth} disabled={nextMonthButtonDisabled} style={{ height: '25px' }}>
                            {">"}
                          </button>
                        </div>
                      );
                    }}
                  />
                </div>

                <div className="datepicker-container" style={{ marginLeft: '5px', zIndex: 10 }}>
                  <label>To:</label>
                  <DatePicker
                    selected={endDate ? new Date(endDate) : null}
                    onChange={handleEndDateChange}
                    dateFormat="MM/dd/yyyy"
                    maxDate={new Date()}
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    yearDropdownItemNumber={100}
                    className={`clnImgTextBoxes ${endDate ? 'default-selected' : ''}`}
                    placeholderText="MM/dd/yyyy"
                    popperPlacement="bottom-start"
                    readOnly={isHideChecked}

                    calendarContainer={CalendarContainer}
                    open={isEndOpen}
                    onFocus={() => setIsEndOpen(true)}
                    onInputClick={() => setIsEndOpen(true)}
                    onClickOutside={() => setIsEndOpen(false)}
                    renderCustomHeader={({ date, changeYear, changeMonth, decreaseMonth, increaseMonth, prevMonthButtonDisabled, nextMonthButtonDisabled }) => {
                      const selectedDate = date instanceof Date && !isNaN(date) ? date : new Date();
                      const selectedMonth = selectedDate.getMonth();
                      const selectedYear = selectedDate.getFullYear();

                      return (
                        <div>
                          <button onClick={decreaseMonth} disabled={prevMonthButtonDisabled} style={{ height: '25px' }}>
                            {"<"}
                          </button>
                          <select
                            value={selectedMonth}
                            onChange={({ target: { value } }) => changeMonth(Number(value))}
                          >
                            {getMonths(selectedYear)}
                          </select>
                          <select
                            value={selectedYear}
                            onChange={({ target: { value } }) => changeYear(Number(value))}
                          >
                            {Array.from({ length: 100 }, (v, k) => (
                              <option key={k} value={new Date().getFullYear() - k}>
                                {new Date().getFullYear() - k}
                              </option>
                            ))}
                          </select>
                          <button onClick={increaseMonth} disabled={nextMonthButtonDisabled} style={{ height: '25px' }}>
                            {">"}
                          </button>
                        </div>
                      );
                    }}
                  />
                </div>


                <div >
                  <label style={{ marginLeft: '25px', marginTop: '3px' }}>All</label>
                  <input
                    style={{ marginLeft: '10px' }}
                    type='checkbox'
                    checked={isHideChecked}
                    onChange={handleHideCheckboxChange}
                  />
                </div>
              </div>

              <div className='locfilter-style'>

                <label>Location:</label>
                <select name="select" style={{
                  width: '140px', marginLeft: '2px', height: '30px', borderRadius: '5px', backgroundColor:
                    selectedLocation !== '-1'
                      ? (locations.find((loc) => loc.LocationId == selectedLocation)?.Color || '#fff')
                      : '#fff'
                }}
                  value={selectedLocation} onChange={handleLocationChange}>

                  <option value="-1">
                    All
                  </option>

                  {locations.map((item, index) => (

                    <option key={index} value={item.LocationId} style={{ backgroundColor: item.Color }}>{item.LocationName}</option>
                  ))}
                </select>
              </div>



              <div className='suggestfilter-style'>
                <div style={{ width: '200px' }}>
                  <label >Search By:</label>
                  <select name="select" id="" style={{ width: '110px', height: '30px', color: 'black' }}
                    value={selectedSearchFilter} onChange={handleFilterChange}>
                    {searchFilterData.map((item, index) => (
                      <option key={item.sFilterType} value={item.sFilterType} >{item.Label}</option>
                    ))}

                  </select>
                </div>




                <div style={{ marginLeft: '1px' }}>
                  <input
                    type='text'
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                    onKeyDown={handleInputKeyPress}

                    style={{ width: '100px', height: '30px' }}
                  />
                  <div className='autocomplete-style'>
                    <ul className='sugglist-style' style={{ width: '100px', fontSize: '1rem' }}>
                      {suggestions.map((suggestion) => (
                        <li key={suggestion.val} value={suggestion.val} onClick={() => handleSuggestionSelect(suggestion)}>{suggestion.label}</li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>


              <div className='searchicon-container' style={{ marginLeft: '10px', marginTop: '5px' }}>
                <FontAwesomeIcon style={{ marginLeft: '7px', marginTop: '5px', cursor: 'pointer', fontSize: '1.5rem' }} onClick={(e) => handleAllClick(e)} icon={faMagnifyingGlass} />
              </div>
            </div>



            <div className='d-flex'>

              <div className='radiostyle-box'>
                {
                  statusRadioButton.map((item, index) => (

                    <div className="btn-group"
                      role="group" aria-label="Basic radio toggle button group"
                      style={{ width: '550px' }} key={index} value={item.ClaimStatus}
                    >

                      <input type="radio" className="btn-check" name="btnradio" id={`btnradio${index}`}

                        value={item.ClaimStatus}
                        onChange={handleRadioButtonsChange}
                        checked={selectedStatusRadioButton === item.ClaimStatus}
                      />

                      <label className="btn btn-outline-primary radiofont-style"
                        htmlFor={`btnradio${index}`} style={{ width: 'max-content' }}>
                        {item.Label}</label>


                    </div>
                  ))

                }

              </div>




              <div style={{ marginLeft: '10px', width: 'max-content' }} className='view-style'>

                View
                <select name="select" id="" style={{
                  marginLeft: '4px', width: '100px', height: '25px', borderRadius: '5px',
                  marginTop: '2px'
                }}
                  value={selectedRecValue}
                  onChange={handleSelectChange}
                >
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="75">75</option>
                  <option value="100">100</option>
                  <option value="all">All</option>
                </select>
                records of {totalRecords} claim(s)

              </div>


              <div className='btnfilter-style'>
                <button className='btn-style' onClick={SendToClearingHouse}>Send to clearing house</button>
              </div>


              <div className='icon-box'>
                <FontAwesomeIcon style={{ marginTop: '5px', cursor: 'pointer' }} onClick={handlePrint} icon={faPrint} />
                <FontAwesomeIcon style={{ marginLeft: '8px', color: 'green', marginTop: '5px', cursor: 'pointer' }} onClick={exportToExcel} icon={faFileExcel} />
                <FontAwesomeIcon style={{ marginLeft: '8px', color: 'red', marginTop: '5px', cursor: 'pointer' }} onClick={exportToPDF} icon={faFilePdf} />


              </div>


            </div>

            {loading && (
              <div className="overlay">
                <div className="spinner-container">
                  <div className="spinner-grow text-danger" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                  <div className="spinner-grow text-warning" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                  <div className="spinner-grow text-info" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              </div>
            )}



          </div>


          <div className='subtable-container'>
            <table className="table table-hover table-striped table-bordered border border-white responsive mt-1 " style={{ marginLeft: '4px', width: '55%' }}>

              <thead>

                <tr className='align-top' >

                  <th className='col-sm col-th  text-white' style={{ backgroundColor: '#0173b7' }}>#</th>


                  <th className='col col-th text-white ' style={{ backgroundColor: '#0173b7', width: '120px' }}>All Claims

                  </th>

                  <th className='col col-th-style  text-white' style={{ backgroundColor: '#c9c9b2', }}>Submitted

                  </th>

                  <th className='col col-th-style  text-white' style={{ backgroundColor: '#c9c9b2', }}>Non-submitted

                  </th>

                  <th className='col col-th-style ' style={{ backgroundColor: '#e9e993', color: 'black' }}>Pending


                  </th>


                  <th className='col col-th-style ' style={{ backgroundColor: '#e9e993', color: 'black' }}>SENT


                  </th>
                  <th className='col col-th-style' style={{ backgroundColor: '#e9e993', color: 'black' }}>FORWARDED


                  </th>




                  <th className='col col-th-style' style={{ backgroundColor: '#e9e993', color: 'black' }}>REJECTED

                  </th>




                </tr>


              </thead>

              <tbody>
                {claimStatusCount.map((item, index) => (

                  <tr key={index}>

                    <th>{index + 1}</th>

                    <td className={`table-bordered border border-white rectext ${activeCounts === 'totalRecords' ? 'active-record' : ''}`} onClick={() => { ReloadClaimsData('all'); handleClaimCountsClick('totalRecords') }}>{item.AllClaims}</td>
                    <td style={{ backgroundColor: '#c9c9b2' }} className={`table-bordered border border-white rectext ${activeCounts === 'submit' ? 'active-record' : ''}`} onClick={() => { ReloadClaimsData('submit', true, ""); handleClaimCountsClick('submit') }}>{item.Submitted}</td>
                    <td style={{ backgroundColor: '#c9c9b2' }} className={`table-bordered border border-white rectext ${activeCounts === 'nonsubmit' ? 'active-record' : ''}`} onClick={() => { ReloadClaimsData('nonsubmit', true, ""); handleClaimCountsClick('nonsubmit') }}>{item.Nonsubmitted}</td>
                    <td style={{ backgroundColor: '#e9e993', color: 'black' }} className={`table-bordered border border-white rectext ${activeCounts === 'pending' ? 'active-record' : ''}`} onClick={() => { ReloadClaimsData('pending', true, ""); handleClaimCountsClick('pending') }}>{item.PendingClaims}</td>
                    <td style={{ backgroundColor: '#e9e993', color: 'black' }} className={`table-bordered border border-white rectext ${activeCounts === 'sent' ? 'active-record' : ''}`} onClick={() => { ReloadClaimsData('sent', true, ""); handleClaimCountsClick('sent') }}>{item.SentClaims}</td>
                    <td style={{ backgroundColor: '#e9e993', color: 'black' }} className={`table-bordered border border-white rectext ${activeCounts === 'fwd' ? 'active-record' : ''}`} onClick={() => { ReloadClaimsData('fwd', true, ""); handleClaimCountsClick('fwd') }}>{item.ForwrdedClaims}</td>
                    <td style={{ backgroundColor: '#e9e993', color: 'black' }} className={`table-bordered border border-white rectext ${activeCounts === 'rejected' ? 'active-record' : ''}`} onClick={() => { ReloadClaimsData('rejected', true, ""); handleClaimCountsClick('rejected') }}>{item.RejectedClaims}</td>

                  </tr>


                ))}
              </tbody>


            </table>



          </div>


          <div className="table-container mt-1 " ref={tableContainerRef} >
            <table className="main_table fixed-header table table-hover border-secondary table-bordered table-info border border-white  responsive mt-1 mb-5" ref={tableRef}>

              <thead>

                <tr className='align-top' >

                  <th className=' border-white col-sm col-th text-white fixed-width-50' style={{ backgroundColor: '#0173b7', width: '50px' }}>#</th>
                  <th className='border-white col col-th-style  text-white' style={{ backgroundColor: '#0173b7', width: '100px' }}>
                    <Link className='text-white' onClick={() => handleSort('LocationNickname')}>Location</Link>
                  </th>
                  <th className='border-white col col-th-style  text-white' style={{ backgroundColor: '#0173b7', width: '110px' }}>
                    <Link className='text-white' onClick={() => handleSort('AppointmentDate')}>DOS</Link>
                    <br />
                    <input style={{ width: '100px', height: '30px', borderRadius: '5px' }} type='text' placeholder='Search'
                      className='hide-on-print'
                      value={searchByDOS}
                      onChange={(e) => setSearchByDOS(e.target.value)}
                    />
                  </th>
                  <th className='border-white col-th text-white ' style={{ backgroundColor: '#0173b7', width: '140px' }}>
                    <Link className='text-white' onClick={() => handleSort('FullName', (item) => `${item.LastName}, ${item.FirstName}`)}>Patient Name</Link>

                    <br />
                    <input style={{ width: '100px', height: '30px', borderRadius: '5px' }}
                      className='hide-on-print'
                      type='text'
                      placeholder='Search'
                      value={searchByPatient}
                      onChange={(e) => setSearchByPatient(e.target.value)}
                    />

                  </th>

                  <th className='border-white col col-th-style  text-white' style={{ backgroundColor: '#0173b7', width: '110px' }}>
                    <Link className='text-white' onClick={() => handleSort('DOB')}>DOB</Link>
                    <br />
                    <input style={{ width: '100px', height: '30px', borderRadius: '5px' }}
                      className='hide-on-print'
                      type='text'
                      placeholder='Search'
                      value={searchByDOB}
                      onChange={(e) => setSearchByDOB(e.target.value)}
                    />
                  </th>


                  <th className='border-white col col-th-style  text-white' style={{ backgroundColor: '#0173b7' }}>
                    <Link className='print-label' style={{ cursor: 'pointer', color: 'white' }} onClick={() => handleSort('Payer')}>Insurance</Link>
                    <input style={{ float: 'right', marginTop: '10px' }} type='checkbox' className='hide-on-print'
                      onChange={() => handleSelectInsuranceAllChange('all')}
                    />
                    <br />

                    <input style={{ width: '100px', height: '30px', borderRadius: '5px', marginLeft: '5px' }} type='text' placeholder='Search'
                      className='hide-on-print'
                      value={searchByInsurance}
                      onChange={(e) => setSearchByInsurance(e.target.value)}
                    />
                    <br />
                    <button className='btn-style3 hide-on-print' onClick={(e) => handleCheckeligibility(e)}>Check</button>


                  </th>




                  <th className='border-white col=sm col-th text-white ' style={{ backgroundColor: '#0173b7', width: '120px' }}>
                    <Link className='text-white' onClick={() => handleSort('ClaimStatus')}>Status</Link>
                    <br />
                    <input style={{ width: '100px', height: '30px', borderRadius: '5px' }}
                      className='hide-on-print'
                      placeholder='Search'
                      value={searchByStatus}
                      onChange={(e) => setSearchByStatus(e.target.value)}
                    />

                  </th>


                  <th className='border-white col col-th-style  text-white' style={{ backgroundColor: '#0173b7', width: '120px' }}>
                    <Link className='text-white' onClick={() => handleSort('ClaimId')}>Claim #</Link>
                    <br />
                    <input style={{ width: '100px', height: '30px', borderRadius: '5px' }} type='text' placeholder='Search'
                      className='hide-on-print'
                      value={searchByClaim}
                      onChange={(e) => setSearchByClaim(e.target.value)}
                    />

                  </th>




                  <th className='border-white col col-th-style  text-white' style={{ backgroundColor: '#0173b7', width: '140px' }}>
                    <Link className='text-white' onClick={() => handleSort('RenderingProvider')}>Provider</Link>
                    <br />
                    <input style={{ width: '120px', height: '30px', borderRadius: '5px' }} type='text' placeholder='Search'
                      className='hide-on-print'
                      value={searchByProvider}
                      onChange={(e) => setSearchByProvider(e.target.value)}
                    />

                  </th>
                  <th className='border-white col col-th-style  text-white' style={{ backgroundColor: '#0173b7' }}>
                    <Link className='text-white' onClick={() => handleSort('EncCPT')}>CPT</Link>
                    <br />
                    <input style={{ width: '100px', height: '30px', borderRadius: '5px' }} type='text' placeholder='Search'
                      className='hide-on-print'
                      value={searchByCPT}
                      onChange={(e) => setSearchByCPT(e.target.value)}
                    />


                  </th>

                  <th className='border-white col col-th-style  text-white' style={{ backgroundColor: '#0173b7' }}>
                    <Link className='text-white' onClick={() => handleSort('EncICD')}>ICD</Link>
                    <br />
                    <input style={{ width: '100px', height: '30px', borderRadius: '5px' }}
                      className='hide-on-print'
                      placeholder='Search'
                      value={searchByICD}
                      onChange={(e) => setSearchByICD(e.target.value)}
                    />
                  </th>
                  <th className='border-white col col-th-style  text-white' style={{ backgroundColor: '#0173b7' }}>
                    <Link className='text-white' onClick={() => handleSort('EncModifier')}>Modifier</Link>
                    <br />
                    <input style={{ width: '100px', height: '30px', borderRadius: '5px' }}
                      className='hide-on-print'
                      placeholder='Search'
                      value={searchByModifier}
                      onChange={(e) => setSearchByModifier(e.target.value)}
                    />
                  </th>


                  <th className='border-white col col-th-style  text-white' style={{ backgroundColor: '#0173b7', width: '120px' }}>
                    <Link className='text-white' onClick={() => handleSort('ClaimTotalSubmitedCharge')}>Total Charge</Link>
                    <br />
                    <input style={{ width: '100px', height: '30px', borderRadius: '5px' }}
                      className='hide-on-print'
                      placeholder='Search'
                      value={searchByTotalCharge}
                      onChange={(e) => setSearchByTotalCharge(e.target.value)}
                    />
                  </th>
                  <th className='border-white col col-th-style  text-white' style={{ backgroundColor: '#0173b7', width: '120px' }}>
                    <Link className='text-white' onClick={() => handleSort('PostingDate')}>Posting Date</Link>
                    <br />
                    <input style={{ width: '100px', height: '30px', borderRadius: '5px' }}
                      className='hide-on-print'
                      placeholder='Search'
                      value={searchByPostingDate}
                      onChange={(e) => setSearchByPostingDate(e.target.value)}
                    />

                  </th>


                  <th className='border-white col col-th-style  text-white' style={{ backgroundColor: '#0173b7', width: '120px' }}>
                    <Link className='text-white' onClick={() => handleSort('SubmitDate')}>Submit Date</Link>
                    <br />
                    <input style={{ width: '100px', height: '30px', borderRadius: '5px' }}
                      className='hide-on-print'
                      placeholder='Search'
                      value={searchBySubmitdate}
                      onChange={(e) => setSearchBySubmitdate(e.target.value)}
                    />
                  </th>



                  <th className='border-white col=sm col-th text-white ' style={{ backgroundColor: '#0173b7', width: '150px' }}>
                    <Link className='text-white' onClick={() => handleSort('ReceivedCharge')}>Recieved Charge</Link>
                    <br />
                    <input style={{ width: '100px', height: '30px', borderRadius: '5px' }}
                      className='hide-on-print'
                      placeholder='Search'
                      value={searchByRecievedCharge}
                      onChange={(e) => setSearchByRecievedCharge(e.target.value)}
                    />

                  </th>

                  <th className='border-white col=sm col-th text-white ' style={{ backgroundColor: '#0173b7', width: '120px' }}>View

                    <br />
                    <input style={{ width: '100px', height: '30px', borderRadius: '5px' }} className='hide-on-print'
                      placeholder='Search'
                    />

                  </th>

                  <th className='border-white col=sm col-th text-white ' style={{ backgroundColor: '#0173b7', width: '150px' }}>
                    <Link className='text-white' onClick={() => handleSort('ClearingHouseName')}>Clearing House</Link>
                  </th>

                  <th className='border-white col=sm col-th text-white ' style={{ backgroundColor: '#0173b7', width: '60px' }}>Send
                    <input style={{ marginLeft: '6px' }} type='checkbox'
                      className='hide-on-print'
                      onChange={() => handleSendSelectAllChange('all')}
                    />
                  </th>


                  <th className='border-white col=sm col-th text-white ' style={{ backgroundColor: '#0173b7', width: '120px' }}>
                    <Link style={{ color: 'white' }} onClick={() => handleSort('UpdatedBy')}>Updated By</Link>

                    <br />
                    <input style={{ width: '100px', height: '30px', borderRadius: '5px' }}
                      className='hide-on-print'
                      placeholder='Search'
                      value={searchByUpdatedBy}
                      onChange={(e) => setSearchByUpdatedBy(e.target.value)}
                    />

                  </th>

                  <th className='border-white col=sm col-th text-white ' style={{ backgroundColor: '#0173b7', width: '140px' }}>
                    <Link style={{ color: 'white' }} onClick={() => handleSort('SubmittedBy')}>Submitted By</Link>

                    <br />
                    <input style={{ width: '100px', height: '30px', borderRadius: '5px' }} className='hide-on-print'
                      placeholder='Search'
                      value={searchBySubmitter}
                      onChange={(e) => setSearchBySubmitter(e.target.value)}
                      autoComplete='off'
                      name="searchBySubmitter"
                      id="searchBySubmitter"
                      onFocus={(e) => e.target.setAttribute("autocomplete", "off")}
                    />

                  </th>

                  <th className=' border-white col-sm col-th text-white ' style={{ backgroundColor: '#0173b7' }}>Attachments

                  </th>

                  <th className='border-white col=sm col-th text-white ' style={{ backgroundColor: '#0173b7', width: '120px' }}><Link style={{ color: 'white' }}>Validate</Link>
                    <input style={{ marginLeft: '3px' }} type='checkbox' />

                  </th>


                  <th className='border-white col=sm col-th text-white hide-on-print' style={{ backgroundColor: '#0173b7', width: '30px' }}>
                    <FontAwesomeIcon style={{ cursor: 'pointer' }} onClick={handleOpenDeleteModal} icon={faTrashCan} />
                    <br />
                    <input style={{ marginLeft: '3px' }} type='checkbox'

                      onChange={() => handleSelectAllChange('all')}

                    />

                  </th>
                </tr>

              </thead>

              <tbody>

                {displayedRecords.length > 0 ? (
                  displayedRecords.slice(0, visibleRecords).map((item, index) => {


                    return (
                      <tr

                        className={`  ${activeRow === index ? 'table-warning' : ''} ${item.DataValidationMessage !== null && item.DataValidationMessage !== '' ? 'table-danger' : ''}`}

                        data-toggle="tooltip"
                        data-placement="top"
                        title={item.DataValidationMessage || ''}
                        key={index}
                        onClick={() => handleRowClick(index)}

                        style={{
                          backgroundColor: index % 2 === 1 ? 'lightblue' : 'inherit',
                        }}


                      >

                        <td className='border-white' scope="row" style={{ fontFamily: 'sans-serif', fontSize: '14px', fontWeight: '500', width: '30px' }}>{index + 1}</td>
                        <td className='border-white ' style={{ width: '100px' }}><label>{item.LocationNickname}</label></td>
                        <td className='border-white ' >

                          <label className='linkspan' onClick={() => handleDosLinkClick(item)}>

                            {formatDOSDate(item.AppointmentDate)}
                          </label>

                        </td>

                        <td className='border-white'>
                          <label className={`linkspan name ${item.EligibilityCheckCount > 0 ? 'EligibilityChecked' : 'EligibilityNotChecked'}`} onClick={() => handlePatLinkClick(item)}>
                            {item.LastName},{item.FirstName}
                          </label>
                          {item.PatSecInscount > 0 && (
                            <span >
                              <FontAwesomeIcon className="show-icon" style={{ marginLeft: '10px' }} icon={faShieldHalved} />
                            </span>
                          )}
                        </td>

                        <td className='border-white '><label className='label-style'>{formatDOSDate(item.DOB)}</label></td>


                        <td className='border-white '>
                          {item.SecPayerID ? (
                            <>
                              <label className='label-style'>{item.SecPayer}</label>
                              <br />
                              <label>{item.SecPayerID}</label>
                              <br />
                              <label className={`print-label payer${index}`} style={{ color: item.PatInsStatus === "Active" ? 'green' : 'red' }}>
                                {item.SecInsPolicyNumber}
                              </label>
                              <br />
                            </>
                          ) : (
                            <>
                              <label className='label-style'>{item.Payer}</label>
                              <br />
                              <label>{item.PayerID}</label>
                              <br />
                              <label className={`print-label payer${index}`} style={{ color: item.PatInsStatus === "Active" ? 'green' : 'red' }}>
                                {item.PolicyNumber}
                              </label>
                              <br />
                            </>
                          )}

                          {!item.IsPrimarySkipped && (
                            <FontAwesomeIcon className="hide-on-print" title="Secondary Claim" style={{ color: 'red', fontSize: '10px' }} icon={faStar} />

                          )}


                          {item.IsPrimarySkipped === true && (
                            <div className="divSkipped">
                              {item.Payer} - (pri) - Skipped
                            </div>
                          )}


                          {rowState[item.ClaimId]?.isHidden && (
                            <FontAwesomeIcon
                              style={{ marginLeft: '5px' }}
                              icon={faSpinner}
                              className={rowState[item.ClaimId]?.isLoading ? 'rotating-icon' : ''}
                            />
                          )}


                          <input style={{ float: 'right', marginRight: '10px', marginTop: '6px' }} type='checkbox' className='hide-on-print'
                            key={index}
                            checked={insuranceAllCheckbox.includes(index)}
                            onChange={() => handleInsuranceRowCheckbox(index, item)}


                          />
                        </td>



                        <td className='border-white '><label>{item.ClaimStatus}</label>

                        </td>

                        <td className='border-white' style={{ backgroundColor: item.UpdatedBy ? 'lightpink' : '' }}>

                          <span onClick={() => handleLinkClick(item)} style={{ cursor: 'pointer', textDecoration: 'underline', color: 'blue' }}>
                            {item.ClaimId}
                          </span>


                          <FontAwesomeIcon className='hide-on-print' style={{ marginLeft: '40px', color: '#000', fontWeight: '100' }} onClick={() => fetchGetAllEvents(item)} icon={faFile} />

                        </td>
                        <td className='border-white '><label className='label-style'>{item.RenderingProvider}</label></td>

                        <td className='border-white '><label className='label-style'>{item.EncCPT.replace(/^,/, '')}</label>

                        </td>
                        <td className='border-white '><label>{item.EncICD}</label>

                        </td>
                        <td className='border-white '><label>{item.EncModifier}</label>

                        </td>

                        <td className='border-white '><label>${item.ClaimTotalSubmitedCharge}</label>

                        </td>
                        <td className='border-white '>
                          <label>
                            {item.SecClaimPostingDate
                              ? formatSubmitDate(item.SecClaimPostingDate)
                              : formatSubmitDate(item.PostingDate)}


                          </label>

                        </td>
                        <td className='border-white '>
                          <label>
                            {item.IsPrimarySkipped
                              ? formatSubmitDate(item.SecClaimSubmiDate)
                              : formatSubmitDate(item.SubmitDate)}
                          </label>


                        </td>

                        <td className='border-white '><label className={getRecievedChargeClass(item.ReceivedCharge)}>{item.ReceivedCharge}</label>

                        </td>

                        <td className='border-white '>
                          <FontAwesomeIcon className='show-icon' style={{ marginLeft: '5px', color: 'red' }} onClick={() => GetPDFCMS(item)} icon={faFilePdf} />
                          {
                            !rowState[item.ClaimId]?.isHidden && (
                              <FontAwesomeIcon
                                style={{ marginLeft: '5px' }}
                                onClick={() => handleRegeneratePDFCMS(item)}
                                icon={faArrowsRotate}
                                className={rowState[item.ClaimId]?.isLoading ? 'rotating-icon hide-on-print' : 'hide-on-print'}
                              />
                            )
                          }

                        </td>

                        <td className='border-white '>
                          <span className="show-on-print">
                            {
                              selectClearinghouse.find(
                                ch => ch.MCHID === item.ClearingHouse
                              )?.ClearingHouseName
                            }
                          </span>

                          <select name="select"
                            className="hide-on-print"
                            value={item.ClearingHouse}
                            onChange={(e) => handleClearinghouseChange(index, e)}
                          >

                            {selectClearinghouse.map((item, index) => (
                              <>

                                <option key={index} value={item.MCHID}>{item.ClearingHouseName}</option>
                              </>

                            ))}
                          </select>
                        </td>

                        <td className='border-white ' style={{ width: '60px' }}>

                          {(item.ClaimStatusInt === "" || item.ClaimStatusInt == 8 || item.ClaimStatusInt === null || item.ClaimStatusInt == 0 || item.ClaimStatusInt == 6) && (
                            <input
                              style={{ marginLeft: '6px' }}
                              type='checkbox'
                              key={index}
                              checked={selectedSendRows.includes(index)}
                              onChange={() => handleSendRowCheckboxChange(index)}
                            />
                          )}
                        </td>

                        <td className='border-white' style={{ textAlign: 'center' }}>
                          {item.UpdatedBy}

                        </td>

                        <td className='border-white ' style={{ textAlign: 'center' }}>
                          {item.SubmittedBy}

                        </td>

                        <td className='border-white'>
                          <Link onClick={() => handleGetClaimAttachments(item)}>{item.Attachments}</Link>
                        </td>
                        <td className='border-white hide-on-print' style={{ textAlign: 'center' }} ><FontAwesomeIcon icon={faCircleCheck} className='success-icon' /></td>


                        <td className='border-white' style={{ width: '30px', textAlign: 'center' }}>

                          <input
                            type='checkbox'
                            key={index}
                            checked={selectedRows.includes(index)}
                            onChange={() => handleRowCheckboxChange(index)}
                          />

                        </td>



                        <input type='hidden' value={item.PatientID} />
                        <input type='hidden' value={item.ClaimId} />
                        <input type='hidden' value={item.DOS} />
                        <input type='hidden' value={item.Encounter} />
                        <input type='hidden' value={item.PriorSecClaim} />
                        <input type='hidden' value={item.Status} />
                        <input type='hidden' value={item.DataValidationMessage} />


                      </tr>

                    )
                  })
                ) : (
                  <tr>
                    <td colSpan="6" style={{ textAlign: "center" }}>No records found</td>
                  </tr>

                )}




              </tbody>



            </table>


            <div className='btn-container2 mt-3' style={{ marginLeft: '2400px', }}>

              <button className='btn-style' onClick={SendToClearingHouse}>Send to clearing house</button>

              <button className='btn-style3' onClick={handleOpenDeleteModal}>Delete</button>
            </div>




            {showSelectErrorModal && (

              <div className='alert-modal'>

                <p>please select atleast one claim...</p>
                <button className='btn btn-primary' onClick={handleCloseModals}>Ok</button>

              </div>

            )}


            {showConfirmSaveModal && (
              <div className='alert-modal'>

                <p>Are you sure to save?</p>
                <button className='btn btn-primary' onClick={handleCloseModals}>close</button>
                <button className='btn btn-primary' style={{ marginLeft: '40px' }} >save</button>
              </div>

            )}



            {showApprovalSaveModal && (
              <div className='alert-modal'>

                <p>Are you sure to save for approval ?</p>
                <button className='btn btn-primary' onClick={handleCloseModals}>close</button>
                <button className='btn btn-primary' style={{ marginLeft: '40px' }}>save</button>
              </div>

            )}






            {showSuccessModal && (
              <div className="alert alert-success mt-2" role="alert" style={{ marginLeft: '1200px', width: '1000px' }}>
                {`${savedRowCount}  claim successfully Saved`}
              </div>

            )}






            {showDeleteModal && (

              <div className='alert-modal' style={{ height: '140px' }}>


                <input type={showPassword ? 'text' : 'password'} style={{ border: "1px solid", height: '30px' }}
                  value={epin}
                  onChange={handleEpinChange}
                  onBlur={handleGetVerifiedEPIN}
                  placeholder="Enter your EPIN"
                  maxLength={4}
                  autoComplete='off'
                />
                <FontAwesomeIcon className='fa'
                  icon={showPassword ? faEye : faEyeSlash}
                  aria-hidden="true"
                  onClick={handleTogglePassword}
                  style={{ cursor: 'pointer', color: 'black' }}
                />



                <h5>Are you sure to delete the selected claims?</h5>
                <button className='btn text-white' style={{ backgroundColor: '#DD7800' }} onClick={handleCloseModals}>close</button>
                <button className='btn text-white' style={{ marginLeft: '10px', backgroundColor: '#DD7800' }} onClick={() => handleDelete(0)}>Delete from Page</button>
                <button className='btn text-white' style={{ marginLeft: '10px', backgroundColor: '#DD7800' }} onClick={() => handleDelete(1)}>Delete Permanently</button>
              </div>
            )}



            {deleteSuccessModal && (
              <div className='alert-modal'>
                <FontAwesomeIcon className='closed-icon' onClick={handleCloseModals} icon={faXmark} />
                <p style={{ color: 'white', marginTop: '30px' }}>  {`${deleteRowCount}  Rows successfully Removed`}!</p>
              </div>
            )}




            {isEPINVerifiedModal && verifiedEpin === 0 && (

              <div className='alert-modal' style={{ marginLeft: '100px', marginTop: '50px' }}>

                <FontAwesomeIcon className='closed-icon' onClick={handleCloseModals} icon={faXmark} />
                <p style={{ color: 'white', marginTop: '30px' }}>Invalid EPIN</p>
              </div>
            )}



            {showPopup && (
              <div style={{
                position: 'fixed',
                bottom: '50px',
                left: '50%',
                transform: 'translateX(-50%)',
                backgroundColor: '#333',
                color: '#fff',
                padding: '10px 20px',
                borderRadius: '5px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
                zIndex: 1000,
                height: '100px',
                width: '400px',
                textAlign: 'center'
              }}>
                <label style={{ marginTop: '20px', fontSize: '1.4rem' }}>{popupMessage}</label>
              </div>
            )}



            {closeClaimsModal && (
              <div className='alert-modal'>

                <div style={{ display: "block" }}>

                  <div>
                    <input type="password" />
                    <i class="fa fa-eye"></i>
                  </div>
                  <div >
                    <button type="button" className='btn btn-primary mt-1' onClick={handleCloseModals}>cancel</button>
                    <button type="button" className='btn btn-primary mt-1' style={{ marginLeft: '8px' }}>confirm</button>

                  </div>
                </div>
              </div>

            )}









            {showFaxModal && (

              <Draggable>
                <div className='dialog-box2'>


                  <table className="table" >

                    <thead>

                      <tr>
                        <td className='topnavsub'>
                          <FontAwesomeIcon style={{ float: 'right', fontWeight: 'bolder', fontSize: '1rem' }} onClick={handleCloseModals} icon={faXmark} />

                        </td>

                      </tr>

                      <tr >

                        <td style={{ backgroundColor: '#ECF7FB' }} >   <label >Claim ID:  {selectedClaimID}  </label></td>

                      </tr>

                      <tr>

                        <td>

                          {eventData.map((item, index) => (
                            <>


                              <div className='event-style' key={index}>
                                <label>{item.DataCurStatus}</label>
                                <br />
                                <label>{formatDOSDate(item.EventDateTime)}- {item.UserFName}</label>

                              </div>

                              {index < eventData.length - 1 && (

                                <FontAwesomeIcon style={{ fontWeight: 'bolder', fontSize: '1.8rem' }} icon={faArrowRight} />

                              )}
                            </>
                          ))}
                        </td>
                      </tr>

                    </thead>

                    <tbody>



                    </tbody>


                  </table>


                </div>
              </Draggable>


            )}




            {showattachmentData && (
              <Draggable>

                <div className='modal-box'>
                  <FontAwesomeIcon style={{
                    width: '18px', height: '18px', borderRadius: '999px', border: '1px solid black',
                    float: 'right', fontWeight: 'bolder', fontSize: '0.9rem', backgroundColor: 'red', color: 'white'
                  }} onClick={handleCloseModals} icon={faXmark} />

                  <label >Claim ID:  {attachmentClaimID}  </label>

                  <div className=' mt-2'>

                    <table className="table table-hover table-striped table-bordered border border-white table-info responsive mt-1 " style={{ marginLeft: '5px', width: '100%' }}>

                      <thead>

                        <tr className="align-top" style={{ fontSize: "0.5rem" }}>
                          <th
                            className="col-sm col-th  text-white border border-white"
                            style={{ backgroundColor: "#0173b7" }}
                          >
                            S NO
                          </th>

                          <th
                            className="col col-th-style  text-white border border-white"
                            style={{ backgroundColor: "#0173b7" }}
                          >
                            Document Name
                          </th>
                          <th
                            className="col col-th-style  text-white border border-white"
                            style={{ backgroundColor: "#0173b7" }}
                          >
                            Preview
                          </th>
                          <th
                            className="col col-th-style  text-white border border-white"
                            style={{ backgroundColor: "#0173b7" }}
                          >
                            Uploaded Date
                          </th>

                          <th className="col col-th-style  text-white border border-white"
                            style={{ backgroundColor: "#0173b7" }}>Type</th>


                          <th className="col col-th-style  text-white border border-white"
                            style={{ backgroundColor: "#0173b7" }}>Method</th>

                          <th className="col col-th-style  text-white border border-white"
                            style={{ backgroundColor: "#0173b7" }}>ACN</th>


                        </tr>


                      </thead>

                      <tbody>
                        {attachmentData.map((item, index) => (

                          <tr

                            key={index}
                          >
                            <td>{index + 1}</td>
                            <td>{item.DocumentName}</td>
                            <td>
                              <FontAwesomeIcon className="hide-on-print" style={{ marginLeft: '5px', color: 'red', cursor: 'pointer' }} onClick={() => GetDOCPDF(item.FileUrl)} icon={faFilePdf} />

                            </td>
                            <td>{formatDOSDate(item.UploadedDate)}</td>
                            <td>
                              {item.PWK01}
                            </td>
                            <td>
                              {item.PWK02}
                            </td>
                            <td>
                              {item.PWK06}
                            </td>


                          </tr>
                        ))}

                      </tbody>
                    </table>

                  </div>
                </div>


              </Draggable>

            )}



          </div>



        </div>


      </div>




    </>
  )
}

export default ClaimApproval